export const customTranslations = {
  en: {
    insurance: {
      title: 'Insurance Sales Practice',
      recommendedProducts: 'Recommended Products',
      conversation: 'Conversation',
      startPractice: 'Start Practice',
      endSession: 'End Session',
      loading: 'Loading...',
      connecting: 'Connecting...',
      relevance: 'Relevance',
      monthlyPremium: 'Monthly Premium',
      coverage: 'Coverage',
      keyFeatures: 'Key Features',
      viewDetails: 'View Details',
      hideDetails: 'Hide Details',
      listeningToClient: 'Client is speaking...',
      readyToStart: 'Ready to Start',
      clientInfo: 'Client Information',
      mainConcerns: 'Main Concerns',
      clientProfile: {
        basicInfo: 'Basic Information',
        name: 'Name',
        age: 'Age',
        occupation: 'Occupation',
        family: 'Family',
        married: 'Married',
        children: 'Children',
        financial: 'Financial Status',
        concerns: 'Main Concerns',
        goals: 'Goals',
        existingCoverage: 'Existing Coverage',
      },
      products: {
        emptyStateTitle: 'Product Recommendations',
        emptyStateMessage:
          'Recommendations will appear as you discuss client needs',
        emptyStateSubtext: 'Products update in real-time during conversation',
        updatingRecommendations: 'Updating recommendations...',
        topRecommendations: 'Recommended Products',
        showing: 'Showing',
        products: 'products',
      },
      feedback: {
        preparingFeedback: 'Preparing your feedback...',
        overallScore: 'Overall Score',
        strengths: 'Strengths',
        improvements: 'Areas for Improvement',
        productAnalysis: 'Product Recommendation Analysis',
        conversationFlow: 'Conversation Flow',
        nextSteps: 'Next Steps',
        practiceAgain: 'Practice Again',
      },
    },
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'Sales Support',
          handlingGuide: 'Handling Guide',
          competitiveIntelligence: 'Competitive Intelligence',
          objectionHandlingGuide: 'Objection Handling Guide',
          responseSuggestions: 'Response Suggestions',
          contextualSuggestions: 'Contextual Suggestions',
          profile: 'Profile',
          clientProfile: 'Client Profile',
          keyFeatures: 'Key Features',
          coreBusiness: 'Core Businesses',
          pricing: 'Pricing',
          practiceSession: 'Practice',
        },
        errors: {
          failedToLoadScenario: 'Failed to load scenario. Please try again.',
          failedToStartSession: 'Failed to start practice session',
          failedToGenerateFeedback:
            'Failed to generate feedback. Please try again.',
          failedToGeneratePdf: 'Failed to generate PDF',
        },
        buttons: {
          connecting: 'Connecting...',
          endSession: 'End Session',
          startPractice: 'Start Practice',
          hide: 'Hide',
          show: 'Show',
          copy: 'Copy',
          unmark: 'Unmark',
          markComplete: 'Mark Complete',
          showRecentTips: 'Show recent tips',
          showAllTips: 'Show all tips',
          listenToFeedback: 'Listen to Feedback',
          pauseFeedback: 'Pause Feedback',
          downloadPdf: 'Download PDF',
          generatePdf: 'Generate PDF',
          practiceAgain: 'Practice Again',
        },
        conversation: {
          toggleClientDetails: 'Toggle client details',
          readyToPractice: 'Ready to Practice',
          youWillBeSpeak: "You'll be speaking with",
          personaDescription: 'a {{age}}-year-old {{occupation}}{{location}}',
          basedIn: ' based in ',
          interested: 'interested',
          inFinancialSolutions: 'in financial solutions but concerned about',
          speakingWith:
            "You'll be speaking with <bold>{{name}}</bold>, a {{age}}-year-old {{occupation}} based in {{location}}.",
          speakingWithNoLocation:
            "You'll be speaking with <bold>{{name}}</bold>, a {{age}}-year-old {{occupation}}.",
        },
        competitors: {
          yourProductAdvantages: 'Your Product Advantages',
          details: 'details',
          type: 'Type:',
          keyFeatures: 'Key Features',
          theirStrengths: 'Their Strengths',
          theirLimitations: 'Their Limitations',
          positioningStrategy: 'Positioning Strategy',
        },
        feedback: {
          frameworkImplementation: 'Framework Implementation',
          examplesFromConversation: 'Examples from your conversation',
          improvementTip: 'Improvement tip',
          keyStrengths: 'Key Strengths',
          noKeyStrengths: 'No key strengths noted in this conversation.',
          noKeyStrengthsNoted: 'No key strengths noted.',
          areasForImprovement: 'Areas for Improvement',
          noAreasForImprovement: 'No areas for improvement identified.',
          noAreasForImprovementNoted: 'No areas for improvement noted.',
          productKnowledge: 'Product Knowledge',
          accuracyScore: 'Accuracy Score:',
          strengths: 'Strengths',
          noProductStrengths:
            'No product strengths identified in this conversation.',
          noProductStrengthsNoted: 'No product strengths noted.',
          factualErrorsFirst: 'Factual errors first with special styling',
          correct: 'Correct:',
          noProductKnowledgeGaps: 'No product knowledge gaps identified.',
          noProductKnowledgeGapsNoted: 'No product knowledge gaps noted.',
          competitorComparisonHandling: 'Competitor Comparison Handling',
          effectivePositioning: 'Effective Positioning',
          noEffectivePositioning:
            'No effective positioning strategies identified.',
          noEffectivePositioningNoted: 'No effective positioning noted.',
          improvementOpportunities: 'Improvement Opportunities',
          noImprovementOpportunities:
            'No improvement opportunities identified.',
          noImprovementOpportunitiesNoted:
            'No improvement opportunities noted.',
          missedPositioningOpportunities: 'Missed Positioning Opportunities:',
          conversationHighlights: 'Conversation Highlights',
          bestPractices: 'Best Practices',
          noBestPractices: 'No best practices identified in this conversation.',
          noBestPracticesNoted: 'No best practices noted.',
          missedOpportunities: 'Missed Opportunities',
          noMissedOpportunities: 'No missed opportunities identified.',
          noMissedOpportunitiesNoted: 'No missed opportunities noted.',
          nextSteps: 'Next Steps',
          preparingFeedback: 'Preparing feedback...',
          reconnecting: 'Reconnecting...',
          loadingAudio: 'Loading audio...',
          generatingPdf: 'Generating PDF...',
          showRecentTips: 'Show recent tips',
          showAllTips: 'Show all tips',
        },
        objectionHandling: {
          guide: 'Objection Handling Guide',
          primaryObjection: 'Primary Objection',
          suggestedResponse: 'Suggested 3Fs Response:',
          suggested3FsResponse: 'Suggested 3Fs Response',
          feel: 'Feel',
          feelText: 'I understand how you feel about',
          feelExample: 'I understand how you feel about',
          feelExampleOneSentence:
            "I understand how you feel. It's completely normal to want clarity before making a decision.",
          commonConcern: "It's a common concern.",
          felt: 'Felt',
          feltText:
            'Many of my clients felt the same way when they were considering this type of product.',
          feltExample:
            'Many of my clients felt the same way when they were considering this type of product.',
          found: 'Found',
          foundText:
            'They found that the long-term benefits and protection offered by our product actually provided excellent value despite the initial concerns.',
          foundExample:
            'They found that the long-term benefits and protection offered by our product actually provided excellent value despite the initial concerns.',
          secondaryObjections: 'Secondary Objections',
          framework: 'Framework',
          frameworkTitleTemplate: '{{name}} Framework',
          watchFor: 'Watch For',
        },
        suggestions: {
          responseSuggestions: 'Response Suggestions',
          understandConcern:
            'I completely understand your concern about the monthly premium.',
          naturalToFeel:
            "It's natural to feel hesitant about making this financial commitment.",
          appreciateOpenness:
            'I appreciate you being open about your budget considerations.',
          clientsFeltSame:
            'Many of my clients initially felt the same way about the cost.',
          workedWithSimilar:
            'I recently worked with someone in a similar situation who had the same concerns.',
          remindsMe:
            'This reminds me of another client who was also worried about the premiums.',
          foundBenefits:
            'They found that the long-term benefits far outweighed the monthly investment.',
          discoveredWaiting:
            'What they discovered was that waiting would actually cost them more.',
          foundPeaceOfMind:
            'In the end, they found peace of mind was worth the investment.',
        },
        objectives: {
          title: 'Roleplay session objectives',
          sessionObjectives: 'Roleplay session objectives',
          acknowledgePriceConcern: 'Acknowledge price concern',
          shareRelevantExperience: 'Share relevant experience',
          demonstrateValueProposition: 'Demonstrate value proposition',
          addressSpecificObjections: 'Address specific objections',
          moveTowardsCommitment: 'Move towards commitment',
        },
        persona: {
          background: 'Background',
          profile: 'Profile',
          style: 'Style',
          nameAndDemographics: 'Name & Demographics',
          occupation: 'Occupation',
          annualIncome: 'Annual Income',
          education: 'Education',
          location: 'Location',
          clientBackground: 'Client Background',
          workHistory: 'Work History',
          financialSituation: 'Financial Situation',
          productKnowledge: 'Product Knowledge',
          keyPriorities: 'Key Priorities',
          communicationStyle: 'Communication Style',
          personalityTraits: 'Personality Traits',
          decisionMaking: 'Decision Making',
          male: 'Male',
          female: 'Female',
          year: 'year',
        },
        mobile: {
          conversation: 'Conversation',
          salesInfo: 'Sales Info',
          guide: 'Guide',
        },
        transcript: {
          title: 'Transcript',
          description: 'Full transcript of your practice session',
        },
      },
      feedback: {
        tabs: {
          summary: 'Summary',
          skillsAssessment: 'Skills assessment',
          transcriptAnalysis: 'Transcript analysis',
        },
        header: {
          title: 'Roleplay feedback',
          iconAlt: 'Roleplay feedback icon',
        },
        errors: {
          transcriptAnalysis: 'Could not get transcript analysis.',
          skillsAssessment: 'Could not get skills assessment.',
          summary: 'Could not get summary.',
        },
        modal: {
          title: 'Roleplay analysis is not available for this session',
          description:
            'Your conversation was too brief to analyze. Complete a longer session to unlock a detailed report on your strengths, areas for improvements, skills assessment, and more!',
          imageAlt: 'Analysis Report Preview',
          closeButton: 'Close',
          metrics: {
            activeCommunication: 'Active communication',
            conflictResolution: 'Conflict resolution',
            empathy: 'Empathy',
            goalSetting: 'Goal setting',
          },
        },
      },
    },
  },
  yue: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: '銷售支援',
          handlingGuide: '處理指南',
          competitiveIntelligence: '競爭情報',
          objectionHandlingGuide: '異議處理指南',
          responseSuggestions: '回應建議',
          contextualSuggestions: '情境建議',
          profile: '個人檔案',
          clientProfile: '客戶檔案',
          keyFeatures: '主要功能',
          pricing: '定價',
        },
        errors: {
          failedToLoadScenario: '載入場景失敗，請重試。',
          failedToStartSession: '開始練習會話失敗',
          failedToGenerateFeedback: '生成反饋失敗，請重試。',
          failedToGeneratePdf: '生成PDF失敗',
        },
        buttons: {
          connecting: '連接緊 ...',
          endSession: '結束會話',
          startPractice: '開始練習',
          hide: '隱藏',
          show: '顯示',
          copy: '複製',
          unmark: '取消標記',
          markComplete: '標記完成',
          showRecentTips: '顯示最近提示',
          showAllTips: '顯示所有提示',
          listenToFeedback: '聆聽反饋',
          pauseFeedback: '暫停反饋',
          downloadPdf: '下載PDF',
          generatePdf: '生成PDF',
          practiceAgain: '再次練習',
        },
        conversation: {
          toggleClientDetails: '切換客戶詳情',
          readyToPractice: '準備練習',
          youWillBeSpeak: '你將與',
          personaDescription: '{{age}}歲嘅{{occupation}}{{location}}',
          basedIn: '，喺',
          interested: '有興趣',
          inFinancialSolutions: '於金融解決方案但擔心',
          speakingWith:
            '你將與 <bold>{{name}}</bold>（{{age}}歲嘅{{occupation}}，喺{{location}}）對話。',
          speakingWithNoLocation:
            '你將與 <bold>{{name}}</bold>（{{age}}歲嘅{{occupation}}）對話。',
        },
        competitors: {
          yourProductAdvantages: '你產品嘅優勢',
          details: '詳情',
          type: '類型：',
          keyFeatures: '主要功能',
          theirStrengths: '佢哋嘅優勢',
          theirLimitations: '佢哋嘅限制',
          positioningStrategy: '定位策略',
        },
        feedback: {
          frameworkImplementation: '框架實施',
          examplesFromConversation: '對話中嘅例子',
          improvementTip: '改善建議',
          keyStrengths: '主要優勢',
          noKeyStrengths: '呢次對話未發現主要優勢。',
          noKeyStrengthsNoted: '無主要優勢記錄。',
          areasForImprovement: '改善範圍',
          noAreasForImprovement: '未發現需要改善嘅地方。',
          noAreasForImprovementNoted: '無改善範圍記錄。',
          productKnowledge: '產品知識',
          accuracyScore: '準確度評分：',
          strengths: '優勢',
          noProductStrengths: '呢次對話未發現產品優勢。',
          noProductStrengthsNoted: '無產品優勢記錄。',
          factualErrorsFirst: '事實錯誤優先處理',
          correct: '正確：',
          noProductKnowledgeGaps: '未發現產品知識嘅缺口。',
          noProductKnowledgeGapsNoted: '無產品知識缺口記錄。',
          competitorComparisonHandling: '競爭對手比較處理',
          effectivePositioning: '有效定位',
          noEffectivePositioning: '未發現有效嘅定位策略。',
          noEffectivePositioningNoted: '無有效定位記錄。',
          improvementOpportunities: '改善機會',
          noImprovementOpportunities: '未發現改善機會。',
          noImprovementOpportunitiesNoted: '無改善機會記錄。',
          missedPositioningOpportunities: '錯失定位機會：',
          conversationHighlights: '對話重點',
          bestPractices: '最佳實踐',
          noBestPractices: '呢次對話未發現最佳實踐。',
          noBestPracticesNoted: '無最佳實踐記錄。',
          missedOpportunities: '錯失機會',
          noMissedOpportunities: '未發現錯失嘅機會。',
          noMissedOpportunitiesNoted: '無錯失機會記錄。',
          nextSteps: '下一步',
          preparingFeedback: '準備反饋中...',
          reconnecting: '重新連接中...',
          loadingAudio: '載入音頻中...',
          generatingPdf: '生成PDF中...',
          showRecentTips: '顯示最近提示',
          showAllTips: '顯示所有提示',
        },
        objectionHandling: {
          guide: '異議處理指南',
          primaryObjection: '主要異議',
          suggestedResponse: '建議3F回應：',
          suggested3FsResponse: '建議3F回應',
          feel: '感受',
          feelText: '我明白你對',
          feelExample: '我明白你對',
          feelExampleOneSentence:
            '我明白你嘅感受。喺做決定之前想清楚明白係好正常嘅。',
          commonConcern: '呢個係常見嘅擔憂。',
          felt: '感到',
          feltText: '我好多客戶喺考慮呢類產品時都有同樣感受。',
          feltExample: '我好多客戶喺考慮呢類產品時都有同樣感受。',
          found: '發現',
          foundText:
            '佢哋發現我哋產品嘅長期利益同保障其實提供咗卓越價值，儘管初期有呢啲擔憂。',
          foundExample:
            '佢哋發現我哋產品嘅長期利益同保障其實提供咗卓越價值，儘管初期有呢啲擔憂。',
          secondaryObjections: '次要異議',
          framework: '框架',
          frameworkTitleTemplate: '{{name}} 框架',
          watchFor: '留意',
        },
        suggestions: {
          responseSuggestions: '回應建議',
          understandConcern: '我完全明白你對月費嘅擔憂。',
          naturalToFeel: '對呢個財務承諾感到猶豫係好自然嘅。',
          appreciateOpenness: '我欣賞你坦誠講出預算考慮。',
          clientsFeltSame: '我好多客戶最初對成本都有同樣感受。',
          workedWithSimilar: '我最近幫過一個類似情況嘅客戶，佢都有同樣擔憂。',
          remindsMe: '呢個令我諗起另一個客戶，佢都擔心保費問題。',
          foundBenefits: '佢哋發現長期利益遠超過月費投資。',
          discoveredWaiting: '佢哋發現等待實際上會花費更多。',
          foundPeaceOfMind: '最終，佢哋發現安心係值得投資嘅。',
        },
        objectives: {
          title: '角色扮演會話目標',
          sessionObjectives: '角色扮演會話目標',
          acknowledgePriceConcern: '承認價格擔憂',
          shareRelevantExperience: '分享相關經驗',
          demonstrateValueProposition: '展示價值主張',
          addressSpecificObjections: '處理具體異議',
          moveTowardsCommitment: '推向承諾',
        },
        persona: {
          background: '背景',
          profile: '個人檔案',
          style: '風格',
          nameAndDemographics: '姓名及人口統計',
          occupation: '職業',
          annualIncome: '年收入',
          education: '教育程度',
          location: '地點',
          clientBackground: '客戶背景',
          workHistory: '工作履歷',
          financialSituation: '財務狀況',
          productKnowledge: '產品知識',
          keyPriorities: '主要優先事項',
          communicationStyle: '溝通風格',
          personalityTraits: '性格特質',
          decisionMaking: '決策方式',
          male: '男性',
          female: '女性',
          year: '年',
        },
      },
      feedback: {
        tabs: {
          summary: '摘要',
          skillsAssessment: '技能評估',
          transcriptAnalysis: '對話記錄分析',
        },
        header: {
          title: '角色扮演反饋',
          iconAlt: '角色扮演反饋圖標',
        },
        errors: {
          transcriptAnalysis: '無法獲取對話記錄分析。',
          skillsAssessment: '無法獲取技能評估。',
          summary: '無法獲取摘要。',
        },
        modal: {
          title: '此會話無法提供角色扮演分析',
          description:
            '你嘅對話太短無法分析。完成一個較長嘅會話以解鎖詳細報告，包括你嘅優勢、改善領域、技能評估等更多內容！',
          imageAlt: '分析報告預覽',
          closeButton: '關閉',
          metrics: {
            activeCommunication: '積極溝通',
            conflictResolution: '衝突解決',
            empathy: '同理心',
            goalSetting: '目標設定',
          },
        },
      },
    },
  },
  cmn: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: '销售支持',
          handlingGuide: '处理指南',
          competitiveIntelligence: '竞争情报',
          objectionHandlingGuide: '异议处理指南',
          responseSuggestions: '回应建议',
          contextualSuggestions: '情境建议',
          profile: '个人资料',
          clientProfile: '客户资料',
          keyFeatures: '主要功能',
          pricing: '定价',
        },
        errors: {
          failedToLoadScenario: '加载场景失败，请重试。',
          failedToStartSession: '启动练习会话失败',
          failedToGenerateFeedback: '生成反馈失败，请重试。',
          failedToGeneratePdf: '生成PDF失败',
        },
        buttons: {
          connecting: '正在连接...',
          endSession: '结束会话',
          startPractice: '开始练习',
          hide: '隐藏',
          show: '显示',
          copy: '复制',
          unmark: '取消标记',
          markComplete: '标记完成',
          showRecentTips: '显示最近提示',
          showAllTips: '显示所有提示',
          listenToFeedback: '听取反馈',
          pauseFeedback: '暂停反馈',
          downloadPdf: '下载PDF',
          generatePdf: '生成PDF',
          practiceAgain: '再次练习',
        },
        conversation: {
          toggleClientDetails: '切换客户详情',
          readyToPractice: '准备练习',
          youWillBeSpeak: '您将与',
          personaDescription: '{{age}}岁的{{occupation}}{{location}}',
          basedIn: '，位于',
          interested: '感兴趣',
          inFinancialSolutions: '于金融解决方案但担心',
          speakingWith:
            '您将与 <bold>{{name}}</bold>（{{age}}岁的{{occupation}}，位于{{location}}）对话。',
          speakingWithNoLocation:
            '您将与 <bold>{{name}}</bold>（{{age}}岁的{{occupation}}）对话。',
        },
        competitors: {
          yourProductAdvantages: '您产品的优势',
          details: '详情',
          type: '类型：',
          keyFeatures: '主要功能',
          theirStrengths: '他们的优势',
          theirLimitations: '他们的限制',
          positioningStrategy: '定位策略',
        },
        feedback: {
          frameworkImplementation: '框架实施',
          examplesFromConversation: '对话中的例子',
          improvementTip: '改进建议',
          keyStrengths: '主要优势',
          noKeyStrengths: '本次对话未发现主要优势。',
          noKeyStrengthsNoted: '未记录主要优势。',
          areasForImprovement: '改进领域',
          noAreasForImprovement: '未发现需要改进的地方。',
          noAreasForImprovementNoted: '未记录改进领域。',
          productKnowledge: '产品知识',
          accuracyScore: '准确度评分：',
          strengths: '优势',
          noProductStrengths: '本次对话未发现产品优势。',
          noProductStrengthsNoted: '未记录产品优势。',
          factualErrorsFirst: '事实错误优先处理',
          correct: '正确：',
          noProductKnowledgeGaps: '未发现产品知识缺口。',
          noProductKnowledgeGapsNoted: '未记录产品知识缺口。',
          competitorComparisonHandling: '竞争对手比较处理',
          effectivePositioning: '有效定位',
          noEffectivePositioning: '未发现有效的定位策略。',
          noEffectivePositioningNoted: '未记录有效定位。',
          improvementOpportunities: '改进机会',
          noImprovementOpportunities: '未发现改进机会。',
          noImprovementOpportunitiesNoted: '未记录改进机会。',
          missedPositioningOpportunities: '错失定位机会：',
          conversationHighlights: '对话亮点',
          bestPractices: '最佳实践',
          noBestPractices: '本次对话未发现最佳实践。',
          noBestPracticesNoted: '未记录最佳实践。',
          missedOpportunities: '错失机会',
          noMissedOpportunities: '未发现错失的机会。',
          noMissedOpportunitiesNoted: '未记录错失机会。',
          nextSteps: '下一步',
          preparingFeedback: '准备反馈中...',
          reconnecting: '重新连接中...',
          loadingAudio: '加载音频中...',
          generatingPdf: '生成PDF中...',
          showRecentTips: '显示最近提示',
          showAllTips: '显示所有提示',
        },
        objectionHandling: {
          guide: '异议处理指南',
          primaryObjection: '主要异议',
          suggestedResponse: '建议3F回应：',
          suggested3FsResponse: '建议3F回应',
          feel: '感受',
          feelText: '我理解您对',
          feelExample: '我理解您对',
          feelExampleOneSentence:
            '我理解您的感受。在做决定之前想要清楚明白是完全正常的。',
          commonConcern: '这是常见的担忧。',
          felt: '感觉',
          feltText: '我的许多客户在考虑此类产品时都有同样的感受。',
          feltExample: '我的许多客户在考虑此类产品时都有同样的感受。',
          found: '发现',
          foundText:
            '他们发现我们产品提供的长期利益和保障实际上提供了卓越的价值，尽管最初有这些担忧。',
          foundExample:
            '他们发现我们产品提供的长期利益和保障实际上提供了卓越的价值，尽管最初有这些担忧。',
          secondaryObjections: '次要异议',
          framework: '框架',
          frameworkTitleTemplate: '{{name}} 框架',
          watchFor: '注意',
        },
        suggestions: {
          responseSuggestions: '回应建议',
          understandConcern: '我完全理解您对月费的担忧。',
          naturalToFeel: '对这项财务承诺感到犹豫是很自然的。',
          appreciateOpenness: '我很欣赏您坦诚地说出预算考虑。',
          clientsFeltSame: '我的许多客户最初对成本都有同样的感受。',
          workedWithSimilar:
            '我最近帮助过一个类似情况的客户，他也有同样的担忧。',
          remindsMe: '这让我想起另一个客户，他也担心保费问题。',
          foundBenefits: '他们发现长期利益远超过月费投资。',
          discoveredWaiting: '他们发现等待实际上会花费更多。',
          foundPeaceOfMind: '最终，他们发现安心是值得投资的。',
        },
        objectives: {
          title: '角色扮演会话目标',
          sessionObjectives: '角色扮演会话目标',
          acknowledgePriceConcern: '承认价格担忧',
          shareRelevantExperience: '分享相关经验',
          demonstrateValueProposition: '展示价值主张',
          addressSpecificObjections: '处理具体异议',
          moveTowardsCommitment: '推向承诺',
        },
        persona: {
          background: '背景',
          profile: '个人资料',
          style: '风格',
          nameAndDemographics: '姓名及人口统计',
          occupation: '职业',
          annualIncome: '年收入',
          education: '教育程度',
          location: '地点',
          clientBackground: '客户背景',
          workHistory: '工作履历',
          financialSituation: '财务状况',
          productKnowledge: '产品知识',
          keyPriorities: '主要优先事项',
          communicationStyle: '沟通风格',
          personalityTraits: '性格特质',
          decisionMaking: '决策方式',
          male: '男性',
          female: '女性',
          year: '年',
        },
      },
      feedback: {
        tabs: {
          summary: '摘要',
          skillsAssessment: '技能评估',
          transcriptAnalysis: '对话记录分析',
        },
        header: {
          title: '角色扮演反馈',
          iconAlt: '角色扮演反馈图标',
        },
        errors: {
          transcriptAnalysis: '无法获取对话记录分析。',
          skillsAssessment: '无法获取技能评估。',
          summary: '无法获取摘要。',
        },
        modal: {
          title: '此会话无法提供角色扮演分析',
          description:
            '您的对话太短无法分析。完成一个较长的会话以解锁详细报告，包括您的优势、改进领域、技能评估等更多内容！',
          imageAlt: '分析报告预览',
          closeButton: '关闭',
          metrics: {
            activeCommunication: '积极沟通',
            conflictResolution: '冲突解决',
            empathy: '同理心',
            goalSetting: '目标设定',
          },
        },
      },
    },
  },
  zh: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: '銷售支援',
          handlingGuide: '處理指南',
          competitiveIntelligence: '競爭情報',
          objectionHandlingGuide: '異議處理指南',
          responseSuggestions: '回應建議',
          contextualSuggestions: '情境建議',
          profile: '個人資料',
          clientProfile: '客戶資料',
          keyFeatures: '主要功能',
          pricing: '定價',
          coreBusiness: '核心業務',
        },
        errors: {
          failedToLoadScenario: '載入情境失敗，請重試。',
          failedToStartSession: '啟動練習對話失敗',
          failedToGenerateFeedback: '生成回饋失敗，請重試。',
          failedToGeneratePdf: '生成PDF失敗',
        },
        buttons: {
          connecting: '連接中...',
          endSession: '結束對話',
          startPractice: '開始練習',
          hide: '隱藏',
          show: '顯示',
          copy: '複製',
          unmark: '取消標記',
          markComplete: '標記完成',
          showRecentTips: '顯示最近提示',
          showAllTips: '顯示所有提示',
          listenToFeedback: '收聽回饋',
          pauseFeedback: '暫停回饋',
          downloadPdf: '下載PDF',
          generatePdf: '生成PDF',
          practiceAgain: '再次練習',
        },
        conversation: {
          toggleClientDetails: '切換客戶詳情',
          readyToPractice: '準備練習',
          youWillBeSpeak: '您將與',
          personaDescription: '{{age}}歲的{{occupation}}{{location}}',
          basedIn: '，位於',
          interested: '有興趣',
          inFinancialSolutions: '於金融解決方案但擔心',
          speakingWith:
            '您將與 <bold>{{name}}</bold>（{{age}}歲的{{occupation}}，位於{{location}}）對話。',
          speakingWithNoLocation:
            '您將與 <bold>{{name}}</bold>（{{age}}歲的{{occupation}}）對話。',
          roleDescription: '角色說明',
          conversationStarter: '對話開場',
          practiceMode: '練習模式',
        },
        competitors: {
          yourProductAdvantages: '您的產品優勢',
          details: '詳情',
          type: '類型：',
          keyFeatures: '主要功能',
          theirStrengths: '他們的優勢',
          theirLimitations: '他們的限制',
          theirPricing: '他們的定價',
          theirTargetMarket: '他們的目標市場',
          theirValueProposition: '他們的價值主張',
          differentiationPoints: '差異化重點',
          competitiveResponse: '競爭回應',
          marketPosition: '市場地位',
          positioningStrategy: '定位策略',
        },
        feedback: {
          frameworkImplementation: '框架實施',
          examplesFromConversation: '對話範例',
          improvementTip: '改進建議',
          keyStrengths: '主要優勢',
          noKeyStrengths: '本次對話未發現主要優勢。',
          noKeyStrengthsNoted: '未記錄主要優勢。',
          areasForImprovement: '待改進領域',
          noAreasForImprovement: '尚未識別出待改進領域。',
          noAreasForImprovementNoted: '未記錄改進領域。',
          productKnowledge: '產品知識',
          accuracyScore: '準確度分數',
          strengths: '優勢',
          noProductStrengths: '本次對話未識別出產品優勢。',
          noProductStrengthsNoted: '未記錄產品優勢。',
          factualErrorsFirst: '事實錯誤優先處理',
          correct: '正確',
          noProductKnowledgeGaps: '未識別出知識缺口。',
          noProductKnowledgeGapsNoted: '未記錄產品知識缺口。',
          competitorComparisonHandling: '競爭對手比較處理',
          effectivePositioning: '有效定位',
          noEffectivePositioning: '未識別出有效定位。',
          noEffectivePositioningNoted: '未記錄有效定位。',
          improvementOpportunities: '改進機會',
          noImprovementOpportunities: '未識別出改進機會。',
          noImprovementOpportunitiesNoted: '未記錄改進機會。',
          missedPositioningOpportunities: '錯失的定位機會',
          conversationHighlights: '對話亮點',
          bestPractices: '最佳實踐',
          noBestPractices: '未識別出最佳實踐。',
          noBestPracticesNoted: '未記錄最佳實踐。',
          missedOpportunities: '錯失機會',
          noMissedOpportunities: '未識別出錯失機會。',
          noMissedOpportunitiesNoted: '未記錄錯失機會。',
          nextSteps: '下一步',
          preparingFeedback: '準備回饋中...',
          reconnecting: '重新連接中...',
          loadingAudio: '載入音訊中...',
          generatingPdf: '生成PDF中...',
          showRecentTips: '顯示最近提示',
          showAllTips: '顯示所有提示',
          overallPerformance: '整體表現',
          communicationStyle: '溝通風格',
          persuasionTechniques: '說服技巧',
          objectionHandling: '異議處理',
          listeningSkills: '傾聽技巧',
          buildingRapport: '建立關係',
          closingTechniques: '成交技巧',
          followUpActions: '後續行動',
          practiceRecommendations: '練習建議',
          skillDevelopment: '技能發展',
          confidenceBuilding: '建立信心',
          preparationTips: '準備技巧',
          roleplayInsights: '角色扮演洞察',
          performanceMetrics: '績效指標',
          improvementPlan: '改進計劃',
          strengthsToLeverage: '可運用的優勢',
          weaknessesToAddress: '需要解決的弱點',
          actionableAdvice: '可行建議',
          practiceFrequency: '練習頻率',
          skillAssessment: '技能評估',
          specificFeedback: '具體回饋',
        },
        objectionHandling: {
          guide: '異議處理指南',
          primaryObjection: '主要異議',
          suggestedResponse: '建議3F回應：',
          suggested3FsResponse: '建議3F回應',
          feel: '感受',
          feelText: '我理解您對',
          feelExample: '我理解您對',
          feelExampleOneSentence:
            '我理解您的感受。在做決定之前想要清楚明白是完全正常的。',
          commonConcern: '這是常見的擔憂。',
          felt: '認同',
          feltText: '我的許多客戶在考慮此類產品時也有同樣的感受。',
          feltExample: '其他人也有同樣的感受',
          found: '發現',
          foundText:
            '他們發現我們產品提供的長期利益和保障實際上提供了卓越的價值，儘管最初有這些擔憂。',
          foundExample:
            '他們發現我們產品提供的長期利益和保障實際上提供了卓越的價值，儘管最初有這些擔憂。',
          secondaryObjections: '次要異議',
          framework: '框架',
          frameworkTitleTemplate: '{{name}} 框架',
          watchFor: '注意',
          feelFeltFound: '感受、認同、發現框架',
          acknowledgeObjection: '承認異議',
          empathizeWithConcern: '同理他們的顧慮',
          shareRelevantExample: '分享相關範例',
          presentSolution: '提出您的解決方案',
          confirmUnderstanding: '確認他們的理解',
          moveForward: '推進對話',
          frameworkGuidance: '框架指導',
          practiceScenarios: '練習情境',
        },
        suggestions: {
          responseSuggestions: '回應建議',
          understandConcern: '我完全理解您對月費的擔憂。',
          naturalToFeel: '對這項財務承諾感到猶豫是很自然的。',
          appreciateOpenness: '我很欣賞您坦誠地說出預算考慮。',
          clientsFeltSame: '我的許多客戶最初對成本都有同樣的感受。',
          workedWithSimilar:
            '我最近幫助過一個類似情況的客戶，他也有同樣的擔憂。',
          remindsMe: '這讓我想起另一個客戶，他也擔心保費問題。',
          foundBenefits: '他們發現長期利益遠超過月費投資。',
          discoveredWaiting: '他們發現等待實際上會花費更多。',
          foundPeaceOfMind: '最終，他們發現安心是值得投資的。',
          useFramework: '使用框架方法',
          acknowledgeFirst: '首先承認他們的顧慮',
          provideEvidence: '提供支持證據',
          askFollowUp: '詢問後續問題',
          summarizeValue: '總結價值主張',
          addressSpecifically: '具體解決他們的顧慮',
          offerAlternative: '提供替代解決方案',
          buildOnStrength: '建立在您產品的優勢上',
          createUrgency: '創造適當的緊迫感',
          confirmInterest: '確認他們的興趣',
          scheduleFollowUp: '安排後續跟進',
        },
        objectives: {
          title: '角色扮演對話目標',
          sessionObjectives: '角色扮演對話目標',
          acknowledgePriceConcern: '承認價格擔憂',
          shareRelevantExperience: '分享相關經驗',
          demonstrateValueProposition: '展示價值主張',
          addressSpecificObjections: '處理具體異議',
          moveTowardsCommitment: '推向承諾',
          primary: '主要目標',
          secondary: '次要目標',
          skillsFocus: '技能重點',
          outcomeGoals: '結果目標',
          measurementCriteria: '衡量標準',
          sessionProgress: '對話進度',
        },
        persona: {
          background: '背景',
          profile: '個人資料',
          style: '風格',
          nameAndDemographics: '姓名與人口統計資料',
          occupation: '職業',
          annualIncome: '年收入',
          education: '教育程度',
          location: '地點',
          clientBackground: '客戶背景',
          workHistory: '工作經歷',
          financialSituation: '財務狀況',
          productKnowledge: '產品知識',
          keyPriorities: '關鍵優先事項',
          communicationStyle: '溝通風格',
          personalityTraits: '性格特質',
          decisionMaking: '決策方式',
          male: '男性',
          female: '女性',
          year: '年',
          name: '姓名',
          role: '角色',
          company: '公司',
          industry: '行業',
          painPoints: '痛點',
          goals: '目標',
          decisionMakingStyle: '決策風格',
          communicationPreference: '溝通偏好',
          budget: '預算',
          timeline: '時間表',
          stakeholders: '利害關係人',
          previousExperience: '過往經驗',
          currentSituation: '當前狀況',
        },
        mobile: {
          conversation: '對話',
          salesInfo: '銷售資訊',
          guide: '指南',
        },
        transcript: {
          title: '對話回顧',
          description: '回顧您的對話並再次練習以提升技能。',
        },
      },
      feedback: {
        tabs: {
          summary: '摘要',
          skillsAssessment: '技能評估',
          transcriptAnalysis: '對話記錄分析',
        },
        header: {
          title: '角色扮演回饋',
          iconAlt: '角色扮演回饋圖示',
        },
        errors: {
          transcriptAnalysis: '無法獲取對話記錄分析。',
          skillsAssessment: '無法獲取技能評估。',
          summary: '無法獲取摘要。',
        },
        modal: {
          title: '此對話無法提供角色扮演分析',
          description:
            '您的對話太短無法分析。完成一個較長的對話以解鎖詳細報告，包括您的優勢、改進領域、技能評估等更多內容！',
          imageAlt: '分析報告預覽',
          closeButton: '關閉',
          metrics: {
            activeCommunication: '積極溝通',
            conflictResolution: '衝突解決',
            empathy: '同理心',
            goalSetting: '目標設定',
          },
        },
      },
    },
  },
  'zh-tw': {
    custom: {
      roleplay: {
        headers: {
          salesSupport: '銷售支援',
          handlingGuide: '處理指南',
          competitiveIntelligence: '競爭情報',
          objectionHandlingGuide: '異議處理指南',
          responseSuggestions: '回應建議',
          contextualSuggestions: '情境建議',
          profile: '個人資料',
          clientProfile: '客戶資料',
          keyFeatures: '主要功能',
          pricing: '定價',
          coreBusiness: '核心業務',
        },
        errors: {
          failedToLoadScenario: '載入情境失敗，請重試。',
          failedToStartSession: '啟動練習對話失敗',
          failedToGenerateFeedback: '生成回饋失敗，請重試。',
          failedToGeneratePdf: '生成PDF失敗',
        },
        buttons: {
          connecting: '連接中...',
          endSession: '結束對話',
          startPractice: '開始練習',
          hide: '隱藏',
          show: '顯示',
          copy: '複製',
          unmark: '取消標記',
          markComplete: '標記完成',
          showRecentTips: '顯示最近提示',
          showAllTips: '顯示所有提示',
          listenToFeedback: '收聽回饋',
          pauseFeedback: '暫停回饋',
          downloadPdf: '下載PDF',
          generatePdf: '生成PDF',
          practiceAgain: '再次練習',
        },
        conversation: {
          toggleClientDetails: '切換客戶詳情',
          readyToPractice: '準備練習',
          youWillBeSpeak: '您將與',
          personaDescription: '{{age}}歲的{{occupation}}{{location}}',
          basedIn: '，位於',
          interested: '有興趣',
          inFinancialSolutions: '於金融解決方案但擔心',
          speakingWith:
            '您將與 <bold>{{name}}</bold>（{{age}}歲的{{occupation}}，位於{{location}}）對話。',
          speakingWithNoLocation:
            '您將與 <bold>{{name}}</bold>（{{age}}歲的{{occupation}}）對話。',
          roleDescription: '角色說明',
          conversationStarter: '對話開場',
          practiceMode: '練習模式',
        },
        competitors: {
          yourProductAdvantages: '您的產品優勢',
          details: '詳情',
          type: '類型：',
          keyFeatures: '主要功能',
          theirStrengths: '他們的優勢',
          theirLimitations: '他們的限制',
          theirPricing: '他們的定價',
          theirTargetMarket: '他們的目標市場',
          theirValueProposition: '他們的價值主張',
          differentiationPoints: '差異化重點',
          competitiveResponse: '競爭回應',
          marketPosition: '市場地位',
          positioningStrategy: '定位策略',
        },
        feedback: {
          frameworkImplementation: '框架實施',
          examplesFromConversation: '對話範例',
          improvementTip: '改進建議',
          keyStrengths: '主要優勢',
          noKeyStrengths: '本次對話未發現主要優勢。',
          noKeyStrengthsNoted: '未記錄主要優勢。',
          areasForImprovement: '待改進領域',
          noAreasForImprovement: '尚未識別出待改進領域。',
          noAreasForImprovementNoted: '未記錄改進領域。',
          productKnowledge: '產品知識',
          accuracyScore: '準確度分數',
          strengths: '優勢',
          noProductStrengths: '本次對話未識別出產品優勢。',
          noProductStrengthsNoted: '未記錄產品優勢。',
          factualErrorsFirst: '事實錯誤優先處理',
          correct: '正確',
          noProductKnowledgeGaps: '未識別出知識缺口。',
          noProductKnowledgeGapsNoted: '未記錄產品知識缺口。',
          competitorComparisonHandling: '競爭對手比較處理',
          effectivePositioning: '有效定位',
          noEffectivePositioning: '未識別出有效定位。',
          noEffectivePositioningNoted: '未記錄有效定位。',
          improvementOpportunities: '改進機會',
          noImprovementOpportunities: '未識別出改進機會。',
          noImprovementOpportunitiesNoted: '未記錄改進機會。',
          missedPositioningOpportunities: '錯失的定位機會',
          conversationHighlights: '對話亮點',
          bestPractices: '最佳實踐',
          noBestPractices: '未識別出最佳實踐。',
          noBestPracticesNoted: '未記錄最佳實踐。',
          missedOpportunities: '錯失機會',
          noMissedOpportunities: '未識別出錯失機會。',
          noMissedOpportunitiesNoted: '未記錄錯失機會。',
          nextSteps: '下一步',
          preparingFeedback: '準備回饋中...',
          reconnecting: '重新連接中...',
          loadingAudio: '載入音訊中...',
          generatingPdf: '生成PDF中...',
          showRecentTips: '顯示最近提示',
          showAllTips: '顯示所有提示',
          overallPerformance: '整體表現',
          communicationStyle: '溝通風格',
          persuasionTechniques: '說服技巧',
          objectionHandling: '異議處理',
          listeningSkills: '傾聽技巧',
          buildingRapport: '建立關係',
          closingTechniques: '成交技巧',
          followUpActions: '後續行動',
          practiceRecommendations: '練習建議',
          skillDevelopment: '技能發展',
          confidenceBuilding: '建立信心',
          preparationTips: '準備技巧',
          roleplayInsights: '角色扮演洞察',
          performanceMetrics: '績效指標',
          improvementPlan: '改進計劃',
          strengthsToLeverage: '可運用的優勢',
          weaknessesToAddress: '需要解決的弱點',
          actionableAdvice: '可行建議',
          practiceFrequency: '練習頻率',
          skillAssessment: '技能評估',
          specificFeedback: '具體回饋',
        },
        objectionHandling: {
          guide: '異議處理指南',
          primaryObjection: '主要異議',
          suggestedResponse: '建議3F回應：',
          suggested3FsResponse: '建議3F回應',
          feel: '感受',
          feelText: '我理解您對',
          feelExample: '我理解您對',
          feelExampleOneSentence:
            '我理解您的感受。在做決定之前想要清楚明白是完全正常的。',
          commonConcern: '這是常見的擔憂。',
          felt: '認同',
          feltText: '我的許多客戶在考慮此類產品時也有同樣的感受。',
          feltExample: '其他人也有同樣的感受',
          found: '發現',
          foundText:
            '他們發現我們產品提供的長期利益和保障實際上提供了卓越的價值，儘管最初有這些擔憂。',
          foundExample:
            '他們發現我們產品提供的長期利益和保障實際上提供了卓越的價值，儘管最初有這些擔憂。',
          secondaryObjections: '次要異議',
          framework: '框架',
          frameworkTitleTemplate: '{{name}} 框架',
          watchFor: '注意',
          feelFeltFound: '感受、認同、發現框架',
          acknowledgeObjection: '承認異議',
          empathizeWithConcern: '同理他們的顧慮',
          shareRelevantExample: '分享相關範例',
          presentSolution: '提出您的解決方案',
          confirmUnderstanding: '確認他們的理解',
          moveForward: '推進對話',
          frameworkGuidance: '框架指導',
          practiceScenarios: '練習情境',
        },
        suggestions: {
          responseSuggestions: '回應建議',
          understandConcern: '我完全理解您對月費的擔憂。',
          naturalToFeel: '對這項財務承諾感到猶豫是很自然的。',
          appreciateOpenness: '我很欣賞您坦誠地說出預算考慮。',
          clientsFeltSame: '我的許多客戶最初對成本都有同樣的感受。',
          workedWithSimilar:
            '我最近幫助過一個類似情況的客戶，他也有同樣的擔憂。',
          remindsMe: '這讓我想起另一個客戶，他也擔心保費問題。',
          foundBenefits: '他們發現長期利益遠超過月費投資。',
          discoveredWaiting: '他們發現等待實際上會花費更多。',
          foundPeaceOfMind: '最終，他們發現安心是值得投資的。',
          useFramework: '使用框架方法',
          acknowledgeFirst: '首先承認他們的顧慮',
          provideEvidence: '提供支持證據',
          askFollowUp: '詢問後續問題',
          summarizeValue: '總結價值主張',
          addressSpecifically: '具體解決他們的顧慮',
          offerAlternative: '提供替代解決方案',
          buildOnStrength: '建立在您產品的優勢上',
          createUrgency: '創造適當的緊迫感',
          confirmInterest: '確認他們的興趣',
          scheduleFollowUp: '安排後續跟進',
        },
        objectives: {
          title: '角色扮演對話目標',
          sessionObjectives: '角色扮演對話目標',
          acknowledgePriceConcern: '承認價格擔憂',
          shareRelevantExperience: '分享相關經驗',
          demonstrateValueProposition: '展示價值主張',
          addressSpecificObjections: '處理具體異議',
          moveTowardsCommitment: '推向承諾',
          primary: '主要目標',
          secondary: '次要目標',
          skillsFocus: '技能重點',
          outcomeGoals: '結果目標',
          measurementCriteria: '衡量標準',
          sessionProgress: '對話進度',
        },
        persona: {
          background: '背景',
          profile: '個人資料',
          style: '風格',
          nameAndDemographics: '姓名與人口統計資料',
          occupation: '職業',
          annualIncome: '年收入',
          education: '教育程度',
          location: '地點',
          clientBackground: '客戶背景',
          workHistory: '工作經歷',
          financialSituation: '財務狀況',
          productKnowledge: '產品知識',
          keyPriorities: '關鍵優先事項',
          communicationStyle: '溝通風格',
          personalityTraits: '性格特質',
          decisionMaking: '決策方式',
          male: '男性',
          female: '女性',
          year: '年',
          name: '姓名',
          role: '角色',
          company: '公司',
          industry: '行業',
          painPoints: '痛點',
          goals: '目標',
          decisionMakingStyle: '決策風格',
          communicationPreference: '溝通偏好',
          budget: '預算',
          timeline: '時間表',
          stakeholders: '利害關係人',
          previousExperience: '過往經驗',
          currentSituation: '當前狀況',
        },
        mobile: {
          conversation: '對話',
          salesInfo: '銷售資訊',
          guide: '指南',
        },
        transcript: {
          title: '對話回顧',
          description: '回顧您的對話並再次練習以提升技能。',
        },
      },
      feedback: {
        tabs: {
          summary: '摘要',
          skillsAssessment: '技能評估',
          transcriptAnalysis: '對話記錄分析',
        },
        header: {
          title: '角色扮演回饋',
          iconAlt: '角色扮演回饋圖示',
        },
        errors: {
          transcriptAnalysis: '無法獲取對話記錄分析。',
          skillsAssessment: '無法獲取技能評估。',
          summary: '無法獲取摘要。',
        },
        modal: {
          title: '此對話無法提供角色扮演分析',
          description:
            '您的對話太短無法分析。完成一個較長的對話以解鎖詳細報告，包括您的優勢、改進領域、技能評估等更多內容！',
          imageAlt: '分析報告預覽',
          closeButton: '關閉',
          metrics: {
            activeCommunication: '積極溝通',
            conflictResolution: '衝突解決',
            empathy: '同理心',
            goalSetting: '目標設定',
          },
        },
      },
    },
  },
  th: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'การสนับสนุนการขาย',
          handlingGuide: 'คู่มือการจัดการ',
          competitiveIntelligence: 'ข้อมูลข่าวกรองการแข่งขัน',
          objectionHandlingGuide: 'คู่มือการจัดการคัดค้าน',
          responseSuggestions: 'คำแนะนำการตอบสนอง',
          contextualSuggestions: 'คำแนะนำตามบริบท',
          profile: 'ประวัติ',
          clientProfile: 'ประวัติลูกค้า',
          keyFeatures: 'คุณสมบัติหลัก',
          coreBusiness: 'ธุรกิจหลัก',
          pricing: 'ราคา',
        },
        errors: {
          failedToLoadScenario:
            'ไม่สามารถโหลดสถานการณ์ได้ กรุณาลองใหม่อีกครั้ง',
          failedToStartSession: 'ไม่สามารถเริ่มเซสชันฝึกปฏิบัติได้',
          failedToGenerateFeedback:
            'ไม่สามารถสร้างข้อเสนอแนะได้ กรุณาลองใหม่อีกครั้ง',
          failedToGeneratePdf: 'ไม่สามารถสร้าง PDF ได้',
        },
        buttons: {
          connecting: 'กำลังเชื่อมต่อ...',
          endSession: 'จบเซสชัน',
          startPractice: 'เริ่มฝึกปฏิบัติ',
          hide: 'ซ่อน',
          show: 'แสดง',
          copy: 'คัดลอก',
          unmark: 'ยกเลิกเครื่องหมาย',
          markComplete: 'ทำเครื่องหมายเสร็จสิ้น',
          showRecentTips: 'แสดงเคล็ดลับล่าสุด',
          showAllTips: 'แสดงเคล็ดลับทั้งหมด',
          listenToFeedback: 'ฟังข้อเสนอแนะ',
          pauseFeedback: 'หยุดข้อเสนอแนะชั่วคราว',
          downloadPdf: 'ดาวน์โหลด PDF',
          generatePdf: 'สร้าง PDF',
          practiceAgain: 'ฝึกปฏิบัติอีกครั้ง',
        },
        conversation: {
          toggleClientDetails: 'เปิด/ปิดรายละเอียดลูกค้า',
          readyToPractice: 'พร้อมฝึกปฏิบัติ',
          youWillBeSpeak: 'คุณจะได้พูดคุยกับ',
          personaDescription: '{{occupation}}อายุ {{age}} ปี{{location}}',
          basedIn: 'ที่อยู่ในพื้นที่',
          interested: 'สนใจ',
          inFinancialSolutions: 'ในโซลูชันทางการเงิน แต่กังวลเรื่อง',
          speakingWith:
            'คุณจะได้พูดคุยกับ <bold>{{name}}</bold> {{occupation}}อายุ {{age}} ปี ที่อยู่ในพื้นที่{{location}}',
          speakingWithNoLocation:
            'คุณจะได้พูดคุยกับ <bold>{{name}}</bold> {{occupation}}อายุ {{age}} ปี',
        },
        competitors: {
          yourProductAdvantages: 'ข้อได้เปรียบของผลิตภัณฑ์ของคุณ',
          details: 'รายละเอียด',
          type: 'ประเภท:',
          keyFeatures: 'คุณสมบัติหลัก',
          theirStrengths: 'จุดแข็งของพวกเขา',
          theirLimitations: 'ข้อจำกัดของพวกเขา',
          positioningStrategy: 'กลยุทธ์การวางตำแหน่ง',
        },
        feedback: {
          frameworkImplementation: 'การนำกรอบงานไปใช้',
          examplesFromConversation: 'ตัวอย่างจากการสนทนาของคุณ',
          improvementTip: 'เคล็ดลับการปรับปรุง',
          keyStrengths: 'จุดแข็งหลัก',
          noKeyStrengths: 'ไม่พบจุดแข็งในการสนทนานี้',
          noKeyStrengthsNoted: 'ไม่พบจุดแข็งหลัก',
          areasForImprovement: 'จุดที่ควรปรับปรุง',
          noAreasForImprovement: 'ไม่พบพื้นที่สำหรับการปรับปรุง',
          noAreasForImprovementNoted: 'ไม่พบจุดที่ควรปรับปรุง',
          productKnowledge: 'ความรู้เกี่ยวกับผลิตภัณฑ์',
          accuracyScore: 'คะแนนความแม่นยำ:',
          strengths: 'จุดแข็ง',
          noProductStrengths: 'ไม่พบจุดแข็งของผลิตภัณฑ์ในการสนทนานี้',
          noProductStrengthsNoted: 'ไม่พบจุดแข็งด้านผลิตภัณฑ์',
          factualErrorsFirst: 'ข้อผิดพลาดด้านข้อเท็จจริงแสดงก่อน',
          correct: 'ถูกต้อง:',
          noProductKnowledgeGaps: 'ไม่พบช่องว่างความรู้ด้านผลิตภัณฑ์',
          noProductKnowledgeGapsNoted: 'ไม่พบช่องว่างความรู้ด้านผลิตภัณฑ์',
          competitorComparisonHandling: 'การจัดการการเปรียบเทียบคู่แข่ง',
          effectivePositioning: 'การวางตำแหน่งที่มีประสิทธิภาพ',
          noEffectivePositioning: 'ไม่พบกลยุทธ์การวางตำแหน่งที่มีประสิทธิภาพ',
          noEffectivePositioningNoted: 'ไม่พบการวางตำแหน่งที่มีประสิทธิภาพ',
          improvementOpportunities: 'โอกาสการปรับปรุง',
          noImprovementOpportunities: 'ไม่พบโอกาสการปรับปรุง',
          noImprovementOpportunitiesNoted: 'ไม่พบโอกาสการปรับปรุง',
          missedPositioningOpportunities: 'โอกาสการวางตำแหน่งที่พลาดไป:',
          conversationHighlights: 'ไฮไลท์การสนทนา',
          bestPractices: 'แนวปฏิบัติที่ดีที่สุด',
          noBestPractices: 'ไม่พบแนวทางปฏิบัติที่ดีที่สุดในการสนทนานี้',
          noBestPracticesNoted: 'ไม่พบแนวปฏิบัติที่ดีที่สุด',
          missedOpportunities: 'โอกาสที่พลาดไป',
          noMissedOpportunities: 'ไม่พบโอกาสที่พลาดไป',
          noMissedOpportunitiesNoted: 'ไม่พบโอกาสที่พลาดไป',
          nextSteps: 'ขั้นตอนถัดไป',
          preparingFeedback: 'กำลังเตรียมข้อเสนอแนะ...',
          reconnecting: 'กำลังเชื่อมต่อใหม่...',
          loadingAudio: 'กำลังโหลดเสียง...',
          generatingPdf: 'กำลังสร้าง PDF...',
          showRecentTips: 'แสดงเคล็ดลับล่าสุด',
          showAllTips: 'แสดงเคล็ดลับทั้งหมด',
        },
        objectionHandling: {
          guide: 'คู่มือการจัดการคัดค้าน',
          primaryObjection: 'การคัดค้านหลัก',
          suggestedResponse: 'การตอบสนอง 3F ที่แนะนำ:',
          suggested3FsResponse: 'การตอบสนอง 3F ที่แนะนำ',
          feel: 'รู้สึก',
          feelText: 'ฉันเข้าใจความรู้สึกของคุณเกี่ยวกับ',
          feelExample: 'ฉันเข้าใจความรู้สึกของคุณเกี่ยวกับ',
          feelExampleOneSentence:
            'ฉันเข้าใจความรู้สึกของคุณ เป็นเรื่องปกติที่ต้องการความชัดเจนก่อนตัดสินใจ',
          commonConcern: 'นี่เป็นความกังวลที่พบได้บ่อย',
          felt: 'เคยรู้สึก',
          feltText:
            'ลูกค้าหลายคนของฉันเคยรู้สึกเช่นเดียวกันเมื่อพิจารณาผลิตภัณฑ์ประเภทนี้',
          feltExample:
            'ลูกค้าหลายคนของฉันเคยรู้สึกเช่นเดียวกันเมื่อพิจารณาผลิตภัณฑ์ประเภทนี้',
          found: 'พบว่า',
          foundText:
            'พวกเขาพบว่าผลประโยชน์ระยะยาวและการคุ้มครองที่ผลิตภัณฑ์ของเราให้นั้นมีมูลค่าที่ยอดเยี่ยม แม้จะมีความกังวลในตอนแรก',
          foundExample:
            'พวกเขาพบว่าผลประโยชน์ระยะยาวและการคุ้มครองที่ผลิตภัณฑ์ของเราให้นั้นมีมูลค่าที่ยอดเยี่ยม แม้จะมีความกังวลในตอนแรก',
          secondaryObjections: 'การคัดค้านรอง',
          framework: 'กรอบงาน',
          frameworkTitleTemplate: '{{name}} กรอบงาน',
          watchFor: 'ระวัง',
        },
        suggestions: {
          responseSuggestions: 'คำแนะนำการตอบสนอง',
          understandConcern:
            'ฉันเข้าใจความกังวลของคุณเกี่ยวกับค่าเบี้ยรายเดือนอย่างสมบูรณ์',
          naturalToFeel:
            'เป็นเรื่องธรรมชาติที่จะรู้สึกลังเลเกี่ยวกับการผูกพันทางการเงินนี้',
          appreciateOpenness: 'ฉันขอบคุณที่คุณเปิดใจเรื่องการพิจารณางบประมาณ',
          clientsFeltSame:
            'ลูกค้าหลายคนของฉันรู้สึกเช่นเดียวกันเกี่ยวกับต้นทุนในตอนแรก',
          workedWithSimilar:
            'เมื่อเร็ว ๆ นี้ ฉันได้ทำงานกับคนที่อยู่ในสถานการณ์คล้าย ๆ กันที่มีความกังวลเดียวกัน',
          remindsMe:
            'สิ่งนี้ทำให้ฉันนึกถึงลูกค้าอีกคนที่กังวลเรื่องเบี้ยประกันเช่นกัน',
          foundBenefits:
            'พวกเขาพบว่าผลประโยชน์ระยะยาวนั้นคุ้มค่ากว่าการลงทุนรายเดือนมาก',
          discoveredWaiting:
            'สิ่งที่พวกเขาค้นพบคือการรอจะทำให้เสียค่าใช้จ่ายมากกว่า',
          foundPeaceOfMind: 'ในที่สุด พวกเขาพบว่าความสบายใจนั้นคุ้มค่าการลงทุน',
        },
        objectives: {
          title: 'วัตถุประสงค์เซสชันสวมบทบาท',
          sessionObjectives: 'วัตถุประสงค์เซสชันสวมบทบาท',
          acknowledgePriceConcern: 'รับทราบความกังวลเรื่องราคา',
          shareRelevantExperience: 'แบ่งปันประสบการณ์ที่เกี่ยวข้อง',
          demonstrateValueProposition: 'แสดงให้เห็นข้อเสนอคุณค่า',
          addressSpecificObjections: 'จัดการกับการคัดค้านเฉพาะ',
          moveTowardsCommitment: 'ก้าวไปสู่การผูกพัน',
        },
        persona: {
          background: 'ภูมิหลัง',
          profile: 'โปรไฟล์',
          style: 'สไตล์',
          nameAndDemographics: 'ชื่อและข้อมูลประชากร',
          occupation: 'อาชีพ',
          annualIncome: 'รายได้ต่อปี',
          education: 'การศึกษา',
          location: 'ที่อยู่',
          clientBackground: 'ภูมิหลังลูกค้า',
          workHistory: 'ประวัติการทำงาน',
          financialSituation: 'สถานการณ์ทางการเงิน',
          productKnowledge: 'ความรู้เกี่ยวกับผลิตภัณฑ์',
          keyPriorities: 'ลำดับความสำคัญหลัก',
          communicationStyle: 'สไตล์การสื่อสาร',
          personalityTraits: 'ลักษณะบุคลิกภาพ',
          decisionMaking: 'การตัดสินใจ',
          male: 'ชาย',
          female: 'หญิง',
          year: 'ปี',
        },
        transcript: {
          title: 'บทสนทนา',
          description: 'บันทึกบทสนทนาฉบับเต็มของเซสชันการฝึกของคุณ',
        },
      },
      feedback: {
        tabs: {
          summary: 'สรุป',
          skillsAssessment: 'การประเมินทักษะ',
          transcriptAnalysis: 'การวิเคราะห์บทสนทนา',
        },
        header: {
          title: 'ข้อเสนอแนะการสวมบทบาท',
          iconAlt: 'ไอคอนข้อเสนอแนะการสวมบทบาท',
        },
        errors: {
          transcriptAnalysis: 'ไม่สามารถรับการวิเคราะห์บทสนทนาได้',
          skillsAssessment: 'ไม่สามารถรับการประเมินทักษะได้',
          summary: 'ไม่สามารถรับสรุปได้',
        },
        modal: {
          title: 'การวิเคราะห์การสวมบทบาทไม่พร้อมใช้งานสำหรับเซสชันนี้',
          description:
            'การสนทนาของคุณสั้นเกินไปสำหรับการวิเคราะห์ ทำเซสชันที่ยาวกว่าเพื่อปลดล็อครายงานที่ละเอียดเกี่ยวกับจุดแข็ง จุดที่ควรปรับปรุง การประเมินทักษะ และอื่น ๆ อีกมากมาย!',
          imageAlt: 'ตัวอย่างรายงานการวิเคราะห์',
          closeButton: 'ปิด',
          metrics: {
            activeCommunication: 'การสื่อสารเชิงรุก',
            conflictResolution: 'การแก้ไขข้อขัดแย้ง',
            empathy: 'การเอาใจใส่',
            goalSetting: 'การตั้งเป้าหมาย',
          },
        },
      },
    },
  },
  ko: {
    insurance: {
      title: '보험 상담 연습',
      recommendedProducts: '추천 상품',
      conversation: '대화',
      startPractice: '연습 시작',
      endSession: '세션 종료',
      loading: '로딩 중...',
      connecting: '연결 중...',
      relevance: '적합도',
      monthlyPremium: '월 보험료',
      coverage: '보장 금액',
      keyFeatures: '주요 특징',
      viewDetails: '상세 보기',
      hideDetails: '접기',
      listeningToClient: '고객이 말하고 있습니다...',
      readyToStart: '시작 준비 완료',
      clientInfo: '고객 정보',
      mainConcerns: '주요 관심사',
      clientProfile: {
        basicInfo: '기본 정보',
        name: '이름',
        age: '나이',
        occupation: '직업',
        family: '가족',
        married: '기혼',
        children: '자녀',
        financial: '재무 상태',
        concerns: '주요 관심사',
        goals: '목표',
        existingCoverage: '기존 가입 보험',
      },
      products: {
        emptyStateTitle: '추천 상품',
        emptyStateMessage: '고객 니즈를 파악하면서',
        emptyStateSubtext: '실시간으로 상품을 추천해드립니다',
        updatingRecommendations: '추천 상품 업데이트 중...',
        topRecommendations: '추천 상품',
        showing: '총',
        products: '개',
      },
      feedback: {
        preparingFeedback: '피드백 준비 중...',
        overallScore: '종합 점수',
        strengths: '강점',
        improvements: '개선 사항',
        productAnalysis: '상품 추천 분석',
        conversationFlow: '대화 흐름',
        nextSteps: '다음 단계',
        practiceAgain: '다시 연습하기',
      },
    },
    custom: {
      roleplay: {
        headers: {
          salesSupport: '영업 지원',
          handlingGuide: '처리 가이드',
          competitiveIntelligence: '경쟁사 정보',
          objectionHandlingGuide: '이의 처리 가이드',
          responseSuggestions: '응답 제안',
          contextualSuggestions: '상황별 제안',
          profile: '프로필',
          clientProfile: '고객 프로필',
          keyFeatures: '핵심보장',
          coreBusiness: '핵심 사업',
          pricing: '가격',
          practiceSession: '연습',
        },
        errors: {
          failedToLoadScenario:
            '시나리오를 불러올 수 없습니다. 다시 시도해 주세요.',
          failedToStartSession: '연습 세션을 시작할 수 없습니다',
          failedToGenerateFeedback:
            '피드백을 생성할 수 없습니다. 다시 시도해 주세요.',
          failedToGeneratePdf: 'PDF를 생성할 수 없습니다',
        },
        buttons: {
          connecting: '연결 중...',
          endSession: '세션 종료',
          startPractice: '연습 시작',
          hide: '숨기기',
          show: '표시',
          copy: '복사',
          unmark: '표시 해제',
          markComplete: '완료 표시',
          showRecentTips: '최근 팁 보기',
          showAllTips: '모든 팁 보기',
          listenToFeedback: '피드백 듣기',
          pauseFeedback: '피드백 일시정지',
          downloadPdf: 'PDF 다운로드',
          generatePdf: 'PDF 생성',
          practiceAgain: '다시 연습하기',
        },
        conversation: {
          toggleClientDetails: '고객 정보 토글',
          readyToPractice: '연습 준비 완료',
          youWillBeSpeak: '다음 고객과 대화하게 됩니다',
          personaDescription: '{{age}}세의 {{occupation}}{{location}}',
          basedIn: ', ',
          interested: '관심이 있으나',
          inFinancialSolutions: '금융 솔루션에 대해 다음을 우려하고 있습니다',
          speakingWith:
            '<bold>{{name}}</bold>, {{age}}세의 {{occupation}}, {{location}} 거주 고객과 대화하게 됩니다.',
          speakingWithNoLocation:
            '<bold>{{name}}</bold>, {{age}}세의 {{occupation}} 고객과 대화하게 됩니다.',
        },
        competitors: {
          yourProductAdvantages: '우리 제품의 장점',
          details: '세부사항',
          type: '유형:',
          keyFeatures: '핵심보장',
          theirStrengths: '경쟁사의 강점',
          theirLimitations: '경쟁사의 한계',
          positioningStrategy: '포지셔닝 전략',
        },
        feedback: {
          frameworkImplementation: '프레임워크 적용',
          examplesFromConversation: '대화에서의 예시',
          improvementTip: '개선 팁',
          keyStrengths: '주요 강점',
          noKeyStrengths: '이번 대화에서 주요 강점이 발견되지 않았습니다.',
          noKeyStrengthsNoted: '기록된 주요 강점이 없습니다.',
          areasForImprovement: '개선이 필요한 영역',
          noAreasForImprovement: '개선이 필요한 영역이 발견되지 않았습니다.',
          noAreasForImprovementNoted: '기록된 개선 영역이 없습니다.',
          productKnowledge: '제품 지식',
          accuracyScore: '정확도 점수:',
          strengths: '강점',
          noProductStrengths: '이번 대화에서 제품 강점이 발견되지 않았습니다.',
          noProductStrengthsNoted: '기록된 제품 강점이 없습니다.',
          factualErrorsFirst: '사실 오류 우선 표시',
          correct: '정답:',
          noProductKnowledgeGaps: '제품 지식 격차가 발견되지 않았습니다.',
          noProductKnowledgeGapsNoted: '기록된 제품 지식 격차가 없습니다.',
          competitorComparisonHandling: '경쟁사 비교 대응',
          effectivePositioning: '효과적인 포지셔닝',
          noEffectivePositioning:
            '효과적인 포지셔닝 전략이 발견되지 않았습니다.',
          noEffectivePositioningNoted: '기록된 효과적인 포지셔닝이 없습니다.',
          improvementOpportunities: '개선 기회',
          noImprovementOpportunities: '개선 기회가 발견되지 않았습니다.',
          noImprovementOpportunitiesNoted: '기록된 개선 기회가 없습니다.',
          missedPositioningOpportunities: '놓친 포지셔닝 기회:',
          conversationHighlights: '대화 하이라이트',
          bestPractices: '모범 사례',
          noBestPractices: '이번 대화에서 모범 사례가 발견되지 않았습니다.',
          noBestPracticesNoted: '기록된 모범 사례가 없습니다.',
          missedOpportunities: '놓친 기회',
          noMissedOpportunities: '놓친 기회가 발견되지 않았습니다.',
          noMissedOpportunitiesNoted: '기록된 놓친 기회가 없습니다.',
          nextSteps: '다음 단계',
          preparingFeedback: '피드백 준비 중...',
          reconnecting: '다시 연결 중...',
          loadingAudio: '오디오 로딩 중...',
          generatingPdf: 'PDF 생성 중...',
          showRecentTips: '최근 팁 보기',
          showAllTips: '모든 팁 보기',
        },
        objectionHandling: {
          guide: '이의 처리 가이드',
          primaryObjection: '주요 이의사항',
          suggestedResponse: '제안된 3F 응답:',
          suggested3FsResponse: '제안된 3F 응답',
          feel: '공감',
          feelText: '고객님의 우려를 충분히 이해합니다',
          feelExample: '고객님의 우려를 충분히 이해합니다',
          feelExampleOneSentence:
            '고객님의 감정을 이해합니다. 결정을 내리기 전에 명확히 알고 싶어하시는 것은 당연합니다.',
          commonConcern: '많은 분들이 가지시는 일반적인 우려사항입니다.',
          felt: '경험',
          feltText:
            '이런 유형의 제품을 고려하실 때 많은 고객님들이 동일한 우려를 갖고 계셨습니다.',
          feltExample:
            '이런 유형의 제품을 고려하실 때 많은 고객님들이 동일한 우려를 갖고 계셨습니다.',
          found: '발견',
          foundText:
            '결과적으로 우리 제품이 제공하는 장기적 혜택과 보장이 초기 우려에도 불구하고 탁월한 가치를 제공한다는 것을 발견하셨습니다.',
          foundExample:
            '결과적으로 우리 제품이 제공하는 장기적 혜택과 보장이 초기 우려에도 불구하고 탁월한 가치를 제공한다는 것을 발견하셨습니다.',
          secondaryObjections: '부차적 이의사항',
          framework: '프레임워크',
          frameworkTitleTemplate: '{{name}} 프레임워크',
          watchFor: '주의사항',
        },
        suggestions: {
          responseSuggestions: '응답 제안',
          understandConcern:
            '월 보험료에 대한 고객님의 우려를 충분히 이해합니다.',
          naturalToFeel:
            '이러한 재정적 결정에 대해 망설이시는 것은 당연합니다.',
          appreciateOpenness:
            '예산 고려사항에 대해 솔직하게 말씀해 주셔서 감사합니다.',
          clientsFeltSame:
            '많은 고객님들이 처음에는 비용에 대해 동일한 우려를 가지셨습니다.',
          workedWithSimilar:
            '최근에 비슷한 상황에서 동일한 우려를 가진 고객님을 도와드린 적이 있습니다.',
          remindsMe: '보험료를 걱정하셨던 다른 고객님이 생각나네요.',
          foundBenefits:
            '장기적인 혜택이 월 투자금액보다 훨씬 크다는 것을 발견하셨습니다.',
          discoveredWaiting:
            '기다리는 것이 오히려 더 많은 비용이 든다는 것을 발견하셨습니다.',
          foundPeaceOfMind:
            '결국 마음의 평화가 투자할 가치가 있다는 것을 발견하셨습니다.',
        },
        objectives: {
          title: '롤플레이 세션 목표',
          sessionObjectives: '롤플레이 세션 목표',
          acknowledgePriceConcern: '가격 우려 인정',
          shareRelevantExperience: '관련 경험 공유',
          demonstrateValueProposition: '가치 제안 시연',
          addressSpecificObjections: '구체적인 이의사항 처리',
          moveTowardsCommitment: '약속으로 이끌기',
        },
        persona: {
          background: '배경',
          profile: '프로필',
          style: '스타일',
          nameAndDemographics: '이름 및 인구통계',
          occupation: '직업',
          annualIncome: '연간 소득',
          education: '학력',
          location: '위치',
          clientBackground: '고객 배경',
          workHistory: '경력 사항',
          financialSituation: '재정 상황',
          productKnowledge: '제품 지식',
          keyPriorities: '주요 우선순위',
          communicationStyle: '커뮤니케이션 스타일',
          personalityTraits: '성격 특성',
          decisionMaking: '의사결정 방식',
          male: '남성',
          female: '여성',
          year: '연',
        },
        mobile: {
          conversation: '대화',
          salesInfo: '영업 정보',
          guide: '가이드',
        },
        transcript: {
          title: '대화 기록',
          description: '연습 세션의 전체 대화 기록',
        },
      },
      feedback: {
        tabs: {
          summary: '요약',
          skillsAssessment: '스킬 평가',
          transcriptAnalysis: '대화 분석',
        },
        header: {
          title: '롤플레이 피드백',
          iconAlt: '롤플레이 피드백 아이콘',
        },
        errors: {
          transcriptAnalysis: '대화 분석을 가져올 수 없습니다.',
          skillsAssessment: '스킬 평가를 가져올 수 없습니다.',
          summary: '요약을 가져올 수 없습니다.',
        },
        modal: {
          title: '이 세션에는 롤플레이 분석을 사용할 수 없습니다',
          description:
            '대화가 너무 짧아 분석할 수 없습니다. 더 긴 세션을 완료하여 강점, 개선 영역, 스킬 평가 등에 대한 상세한 보고서를 확인하세요!',
          imageAlt: '분석 보고서 미리보기',
          closeButton: '닫기',
          metrics: {
            activeCommunication: '적극적 소통',
            conflictResolution: '갈등 해결',
            empathy: '공감능력',
            goalSetting: '목표 설정',
          },
        },
      },
    },
  },
  id: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'Dukungan Penjualan',
          handlingGuide: 'Panduan Penanganan',
          competitiveIntelligence: 'Intelijen Kompetitif',
          objectionHandlingGuide: 'Panduan Menangani Keberatan',
          responseSuggestions: 'Saran Tanggapan',
          contextualSuggestions: 'Saran Kontekstual',
          profile: 'Profil',
          clientProfile: 'Profil Klien',
          keyFeatures: 'Fitur Utama',
          coreBusiness: 'Bisnis Inti',
          pricing: 'Harga',
          practiceSession: 'Latihan',
        },
        errors: {
          failedToLoadScenario: 'Gagal memuat skenario. Silakan coba lagi.',
          failedToStartSession: 'Gagal memulai sesi latihan',
          failedToGenerateFeedback:
            'Gagal membuat umpan balik. Silakan coba lagi.',
          failedToGeneratePdf: 'Gagal membuat PDF',
        },
        buttons: {
          connecting: 'Menghubungkan...',
          endSession: 'Akhiri Sesi',
          startPractice: 'Mulai Latihan',
          hide: 'Sembunyikan',
          show: 'Tampilkan',
          copy: 'Salin',
          unmark: 'Hapus Tanda',
          markComplete: 'Tandai Selesai',
          showRecentTips: 'Tampilkan tips terbaru',
          showAllTips: 'Tampilkan semua tips',
          listenToFeedback: 'Dengarkan Umpan Balik',
          pauseFeedback: 'Jeda Umpan Balik',
          downloadPdf: 'Unduh PDF',
          generatePdf: 'Buat PDF',
          practiceAgain: 'Latihan Lagi',
        },
        conversation: {
          toggleClientDetails: 'Alihkan detail klien',
          readyToPractice: 'Siap Berlatih',
          youWillBeSpeak: 'Anda akan berbicara dengan',
          personaDescription:
            'seorang {{occupation}} berusia {{age}} tahun{{location}}',
          basedIn: ' yang berada di ',
          interested: 'tertarik',
          inFinancialSolutions: 'pada solusi keuangan namun khawatir tentang',
          speakingWith:
            'Anda akan berbicara dengan <bold>{{name}}</bold>, seorang {{occupation}} berusia {{age}} tahun yang berada di {{location}}.',
          speakingWithNoLocation:
            'Anda akan berbicara dengan <bold>{{name}}</bold>, seorang {{occupation}} berusia {{age}} tahun.',
        },
        competitors: {
          yourProductAdvantages: 'Keunggulan Produk Anda',
          details: 'detail',
          type: 'Tipe:',
          keyFeatures: 'Fitur Utama',
          theirStrengths: 'Kekuatan Mereka',
          theirLimitations: 'Keterbatasan Mereka',
          positioningStrategy: 'Strategi Positioning',
        },
        feedback: {
          frameworkImplementation: 'Implementasi Framework',
          examplesFromConversation: 'Contoh dari percakapan Anda',
          improvementTip: 'Tips perbaikan',
          keyStrengths: 'Kekuatan Utama',
          noKeyStrengths:
            'Tidak ada kekuatan utama yang teridentifikasi dalam percakapan ini.',
          noKeyStrengthsNoted: 'Tidak ada kekuatan utama yang tercatat.',
          areasForImprovement: 'Area untuk Perbaikan',
          noAreasForImprovement:
            'Tidak ada area perbaikan yang teridentifikasi.',
          noAreasForImprovementNoted: 'Tidak ada area perbaikan yang tercatat.',
          productKnowledge: 'Pengetahuan Produk',
          accuracyScore: 'Skor Akurasi:',
          strengths: 'Kekuatan',
          noProductStrengths:
            'Tidak ada kekuatan produk yang teridentifikasi dalam percakapan ini.',
          noProductStrengthsNoted: 'Tidak ada kekuatan produk yang tercatat.',
          factualErrorsFirst: 'Kesalahan faktual ditampilkan terlebih dahulu',
          correct: 'Benar:',
          noProductKnowledgeGaps:
            'Tidak ada celah pengetahuan produk yang teridentifikasi.',
          noProductKnowledgeGapsNoted:
            'Tidak ada celah pengetahuan produk yang tercatat.',
          competitorComparisonHandling: 'Penanganan Perbandingan Kompetitor',
          effectivePositioning: 'Positioning Efektif',
          noEffectivePositioning:
            'Tidak ada strategi positioning efektif yang teridentifikasi.',
          noEffectivePositioningNoted:
            'Tidak ada positioning efektif yang tercatat.',
          improvementOpportunities: 'Peluang Perbaikan',
          noImprovementOpportunities:
            'Tidak ada peluang perbaikan yang teridentifikasi.',
          noImprovementOpportunitiesNoted:
            'Tidak ada peluang perbaikan yang tercatat.',
          missedPositioningOpportunities: 'Peluang Positioning yang Terlewat:',
          conversationHighlights: 'Sorotan Percakapan',
          bestPractices: 'Praktik Terbaik',
          noBestPractices:
            'Tidak ada praktik terbaik yang teridentifikasi dalam percakapan ini.',
          noBestPracticesNoted: 'Tidak ada praktik terbaik yang tercatat.',
          missedOpportunities: 'Peluang yang Terlewat',
          noMissedOpportunities:
            'Tidak ada peluang yang terlewat yang teridentifikasi.',
          noMissedOpportunitiesNoted:
            'Tidak ada peluang yang terlewat yang tercatat.',
          nextSteps: 'Langkah Selanjutnya',
          preparingFeedback: 'Menyiapkan umpan balik...',
          reconnecting: 'Menghubungkan kembali...',
          loadingAudio: 'Memuat audio...',
          generatingPdf: 'Membuat PDF...',
          showRecentTips: 'Tampilkan tips terbaru',
          showAllTips: 'Tampilkan semua tips',
        },
        objectionHandling: {
          guide: 'Panduan Menangani Keberatan',
          primaryObjection: 'Keberatan Utama',
          suggestedResponse: 'Tanggapan 3F yang Disarankan:',
          suggested3FsResponse: 'Tanggapan 3F yang Disarankan',
          feel: 'Merasa',
          feelText: 'Saya memahami perasaan Anda tentang',
          feelExample: 'Saya memahami perasaan Anda tentang',
          feelExampleOneSentence:
            'Saya memahami perasaan Anda. Sangat wajar untuk menginginkan kejelasan sebelum membuat keputusan.',
          commonConcern: 'Ini adalah kekhawatiran yang umum.',
          felt: 'Merasakan',
          feltText:
            'Banyak klien saya merasakan hal yang sama ketika mereka mempertimbangkan jenis produk ini.',
          feltExample:
            'Banyak klien saya merasakan hal yang sama ketika mereka mempertimbangkan jenis produk ini.',
          found: 'Menemukan',
          foundText:
            'Mereka menemukan bahwa manfaat jangka panjang dan perlindungan yang ditawarkan produk kami sebenarnya memberikan nilai yang sangat baik meskipun ada kekhawatiran awal.',
          foundExample:
            'Mereka menemukan bahwa manfaat jangka panjang dan perlindungan yang ditawarkan produk kami sebenarnya memberikan nilai yang sangat baik meskipun ada kekhawatiran awal.',
          secondaryObjections: 'Keberatan Sekunder',
          framework: 'Framework',
          frameworkTitleTemplate: 'Kerangka Kerja {{name}}',
          watchFor: 'Perhatikan',
        },
        suggestions: {
          responseSuggestions: 'Saran Tanggapan',
          understandConcern:
            'Saya sangat memahami kekhawatiran Anda tentang premi bulanan.',
          naturalToFeel:
            'Wajar jika merasa ragu tentang komitmen finansial ini.',
          appreciateOpenness:
            'Saya menghargai keterbukaan Anda tentang pertimbangan anggaran.',
          clientsFeltSame:
            'Banyak klien saya awalnya memiliki perasaan yang sama tentang biaya.',
          workedWithSimilar:
            'Saya baru-baru ini bekerja dengan seseorang dalam situasi serupa yang memiliki kekhawatiran yang sama.',
          remindsMe:
            'Ini mengingatkan saya pada klien lain yang juga khawatir tentang premi.',
          foundBenefits:
            'Mereka menemukan bahwa manfaat jangka panjang jauh melebihi investasi bulanan.',
          discoveredWaiting:
            'Yang mereka temukan adalah menunggu sebenarnya akan menghabiskan biaya lebih banyak.',
          foundPeaceOfMind:
            'Pada akhirnya, mereka menemukan ketenangan pikiran layak untuk diinvestasikan.',
        },
        objectives: {
          title: 'Tujuan sesi bermain peran',
          sessionObjectives: 'Tujuan sesi bermain peran',
          acknowledgePriceConcern: 'Mengakui kekhawatiran harga',
          shareRelevantExperience: 'Berbagi pengalaman yang relevan',
          demonstrateValueProposition: 'Mendemonstrasikan proposisi nilai',
          addressSpecificObjections: 'Mengatasi keberatan spesifik',
          moveTowardsCommitment: 'Bergerak menuju komitmen',
        },
        persona: {
          background: 'Latar Belakang',
          profile: 'Profil',
          style: 'Gaya',
          nameAndDemographics: 'Nama & Demografi',
          occupation: 'Pekerjaan',
          annualIncome: 'Pendapatan Tahunan',
          education: 'Pendidikan',
          location: 'Lokasi',
          clientBackground: 'Latar Belakang Klien',
          workHistory: 'Riwayat Pekerjaan',
          financialSituation: 'Situasi Keuangan',
          productKnowledge: 'Pengetahuan Produk',
          keyPriorities: 'Prioritas Utama',
          communicationStyle: 'Gaya Komunikasi',
          personalityTraits: 'Sifat Kepribadian',
          decisionMaking: 'Pengambilan Keputusan',
          male: 'Laki-laki',
          female: 'Perempuan',
          year: 'tahun',
        },
        mobile: {
          conversation: 'Percakapan',
          salesInfo: 'Info Penjualan',
          guide: 'Panduan',
        },
        transcript: {
          title: 'Transkrip',
          description: 'Transkrip lengkap dari sesi latihan Anda',
        },
      },
      feedback: {
        tabs: {
          summary: 'Ringkasan',
          skillsAssessment: 'Penilaian keterampilan',
          transcriptAnalysis: 'Analisis transkrip',
        },
        header: {
          title: 'Umpan balik bermain peran',
          iconAlt: 'Ikon umpan balik bermain peran',
        },
        errors: {
          transcriptAnalysis: 'Tidak dapat mengambil analisis transkrip.',
          skillsAssessment: 'Tidak dapat mengambil penilaian keterampilan.',
          summary: 'Tidak dapat mengambil ringkasan.',
        },
        modal: {
          title: 'Analisis bermain peran tidak tersedia untuk sesi ini',
          description:
            'Percakapan Anda terlalu singkat untuk dianalisis. Selesaikan sesi yang lebih panjang untuk membuka laporan terperinci tentang kekuatan, area perbaikan, penilaian keterampilan, dan banyak lagi!',
          imageAlt: 'Pratinjau Laporan Analisis',
          closeButton: 'Tutup',
          metrics: {
            activeCommunication: 'Komunikasi aktif',
            conflictResolution: 'Resolusi konflik',
            empathy: 'Empati',
            goalSetting: 'Penetapan tujuan',
          },
        },
      },
    },
  },
  ja: {
    insurance: {
      title: '保険セールス練習',
      recommendedProducts: 'おすすめ商品',
      conversation: '会話',
      startPractice: '練習開始',
      endSession: 'セッション終了',
      loading: '読み込み中...',
      connecting: '接続中...',
      relevance: '適合度',
      monthlyPremium: '月額保険料',
      coverage: '保障金額',
      keyFeatures: '主な特徴',
      viewDetails: '詳細を見る',
      hideDetails: '閉じる',
      listeningToClient: 'お客様が話しています...',
      readyToStart: '開始準備完了',
      clientInfo: 'お客様情報',
      mainConcerns: '主なお悩み',
      clientProfile: {
        basicInfo: '基本情報',
        name: '氏名',
        age: '年齢',
        occupation: '職業',
        family: '家族',
        married: '既婚',
        children: '子供',
        financial: '経済状況',
        concerns: '主なお悩み',
        goals: '目標',
        existingCoverage: '現在の保障',
      },
      products: {
        emptyStateTitle: 'おすすめ商品',
        emptyStateMessage: 'お客様のニーズを把握しながら',
        emptyStateSubtext: 'リアルタイムで商品を推薦します',
        updatingRecommendations: 'おすすめ商品を更新中...',
        topRecommendations: 'おすすめ商品',
        showing: '表示中',
        products: '件',
      },
      feedback: {
        preparingFeedback: 'フィードバック準備中...',
        overallScore: '総合スコア',
        strengths: '強み',
        improvements: '改善点',
        productAnalysis: '商品推薦分析',
        conversationFlow: '会話の流れ',
        nextSteps: '次のステップ',
        practiceAgain: 'もう一度練習する',
      },
    },
    custom: {
      roleplay: {
        headers: {
          salesSupport: '営業サポート',
          handlingGuide: '対応ガイド',
          competitiveIntelligence: '競合インテリジェンス',
          objectionHandlingGuide: '異議対応ガイド',
          responseSuggestions: '回答の提案',
          contextualSuggestions: '状況に応じた提案',
          profile: 'プロフィール',
          clientProfile: '顧客プロフィール',
          keyFeatures: '主な機能',
          coreBusiness: 'コアビジネス',
          pricing: '価格設定',
          practiceSession: '練習',
        },
        errors: {
          failedToLoadScenario:
            'シナリオの読み込みに失敗しました。もう一度お試しください。',
          failedToStartSession: '練習セッションの開始に失敗しました',
          failedToGenerateFeedback:
            'フィードバックの生成に失敗しました。もう一度お試しください。',
          failedToGeneratePdf: 'PDFの生成に失敗しました',
        },
        buttons: {
          connecting: '接続中...',
          endSession: 'セッション終了',
          startPractice: '練習を開始',
          hide: '非表示',
          show: '表示',
          copy: 'コピー',
          unmark: 'マーク解除',
          markComplete: '完了マーク',
          showRecentTips: '最近のヒントを表示',
          showAllTips: 'すべてのヒントを表示',
          listenToFeedback: 'フィードバックを聞く',
          pauseFeedback: 'フィードバック一時停止',
          downloadPdf: 'PDFダウンロード',
          generatePdf: 'PDF生成',
          practiceAgain: 'もう一度練習',
        },
        conversation: {
          toggleClientDetails: '顧客詳細の表示切替',
          readyToPractice: '練習の準備ができました',
          youWillBeSpeak: '以下の方とお話しします',
          personaDescription: '{{age}}歳の{{occupation}}{{location}}',
          basedIn: ', ',
          interested: '興味を持っている',
          inFinancialSolutions: '金融ソリューションに対して、しかし懸念がある',
          speakingWith:
            'これから <bold>{{name}}</bold>（{{age}}歳・{{occupation}}・{{location}}在住） と会話します。',
          speakingWithNoLocation:
            'これから <bold>{{name}}</bold>（{{age}}歳・{{occupation}}） と会話します。',
        },
        competitors: {
          yourProductAdvantages: '御社製品の優位性',
          details: '詳細',
          type: 'タイプ:',
          keyFeatures: '主な機能',
          theirStrengths: '競合の強み',
          theirLimitations: '競合の制限',
          positioningStrategy: 'ポジショニング戦略',
        },
        feedback: {
          frameworkImplementation: 'フレームワークの実装',
          examplesFromConversation: '会話からの例',
          improvementTip: '改善のヒント',
          keyStrengths: '主な強み',
          noKeyStrengths: 'この会話では主な強みが確認されませんでした。',
          noKeyStrengthsNoted: '主な強みは確認されませんでした。',
          areasForImprovement: '改善すべき点',
          noAreasForImprovement: '改善すべき点は確認されませんでした。',
          noAreasForImprovementNoted: '改善すべき点は確認されませんでした。',
          productKnowledge: '製品知識',
          accuracyScore: '正確性スコア:',
          strengths: '強み',
          noProductStrengths: 'この会話では製品の強みが確認されませんでした。',
          noProductStrengthsNoted: '製品の強みは確認されませんでした。',
          factualErrorsFirst: '事実誤認を優先的に表示',
          correct: '正解:',
          noProductKnowledgeGaps: '製品知識のギャップは確認されませんでした。',
          noProductKnowledgeGapsNoted:
            '製品知識のギャップは確認されませんでした。',
          competitorComparisonHandling: '競合比較への対応',
          effectivePositioning: '効果的なポジショニング',
          noEffectivePositioning:
            '効果的なポジショニング戦略は確認されませんでした。',
          noEffectivePositioningNoted:
            '効果的なポジショニングは確認されませんでした。',
          improvementOpportunities: '改善の機会',
          noImprovementOpportunities: '改善の機会は確認されませんでした。',
          noImprovementOpportunitiesNoted: '改善の機会は確認されませんでした。',
          missedPositioningOpportunities: '逃したポジショニングの機会:',
          conversationHighlights: '会話のハイライト',
          bestPractices: 'ベストプラクティス',
          noBestPractices:
            'この会話ではベストプラクティスが確認されませんでした。',
          noBestPracticesNoted: 'ベストプラクティスは確認されませんでした。',
          missedOpportunities: '逃した機会',
          noMissedOpportunities: '逃した機会は確認されませんでした。',
          noMissedOpportunitiesNoted: '逃した機会は確認されませんでした。',
          nextSteps: '次のステップ',
          preparingFeedback: 'フィードバック準備中...',
          reconnecting: '再接続中...',
          loadingAudio: '音声読み込み中...',
          generatingPdf: 'PDF生成中...',
          showRecentTips: '最近のヒントを表示',
          showAllTips: 'すべてのヒントを表示',
        },
        objectionHandling: {
          guide: '異議対応ガイド',
          primaryObjection: '主な異議',
          suggestedResponse: '推奨される3F対応:',
          suggested3FsResponse: '推奨される3F対応',
          feel: '共感',
          feelText: 'お気持ちはよく分かります',
          feelExample: 'お気持ちはよく分かります',
          feelExampleOneSentence:
            'お気持ちはよく分かります。決断する前に明確にしたいと思うのは当然のことです。',
          commonConcern: 'よくある懸念です。',
          felt: '経験',
          feltText:
            '多くのお客様がこのタイプの商品を検討する際、同じように感じられていました。',
          feltExample:
            '多くのお客様がこのタイプの商品を検討する際、同じように感じられていました。',
          found: '発見',
          foundText:
            'そして、当社商品が提供する長期的なメリットと保護が、初期の懸念にもかかわらず優れた価値を提供することを発見されました。',
          foundExample:
            'そして、当社商品が提供する長期的なメリットと保護が、初期の懸念にもかかわらず優れた価値を提供することを発見されました。',
          secondaryObjections: '副次的な異議',
          framework: 'フレームワーク',
          frameworkTitleTemplate: '{{name}} フレームワーク',
          watchFor: '注意点',
        },
        suggestions: {
          responseSuggestions: '回答の提案',
          understandConcern:
            '月額保険料についてのご懸念は十分に理解しています。',
          naturalToFeel:
            'この財務的なコミットメントについて躊躇されるのは自然なことです。',
          appreciateOpenness:
            '予算についてのご検討事項を率直にお話しいただき、ありがとうございます。',
          clientsFeltSame:
            '多くのお客様が最初はコストについて同じように感じられていました。',
          workedWithSimilar:
            '最近、同じような状況で同じ懸念をお持ちの方をサポートいたしました。',
          remindsMe: '保険料を心配されていた別のお客様を思い出します。',
          foundBenefits:
            '長期的なメリットが月々の投資を大きく上回ることを発見されました。',
          discoveredWaiting:
            '待つことが実際にはより多くのコストがかかることを発見されました。',
          foundPeaceOfMind:
            '最終的に、心の平穏が投資する価値があることを発見されました。',
        },
        objectives: {
          title: 'ロールプレイセッションの目標',
          sessionObjectives: 'ロールプレイセッションの目標',
          acknowledgePriceConcern: '価格への懸念を認識',
          shareRelevantExperience: '関連する経験を共有',
          demonstrateValueProposition: '価値提案を実証',
          addressSpecificObjections: '具体的な異議に対応',
          moveTowardsCommitment: 'コミットメントに向けて進む',
        },
        persona: {
          background: '背景',
          profile: 'プロフィール',
          style: 'スタイル',
          nameAndDemographics: '名前と人口統計',
          occupation: '職業',
          annualIncome: '年収',
          education: '学歴',
          location: '所在地',
          clientBackground: '顧客の背景',
          workHistory: '職歴',
          financialSituation: '状況',
          productKnowledge: '製品知識',
          keyPriorities: '主な優先事項',
          communicationStyle: 'コミュニケーションスタイル',
          personalityTraits: '性格特性',
          decisionMaking: '意思決定',
          male: '男',
          female: '男',
          year: '年',
        },
        mobile: {
          conversation: '会話',
          salesInfo: '営業情報',
          guide: 'ガイド',
        },
        transcript: {
          title: '会話記録',
          description: '練習セッションの完全な会話記録',
        },
      },
      feedback: {
        tabs: {
          summary: '要約',
          skillsAssessment: 'スキル評価',
          transcriptAnalysis: '会話記録分析',
        },
        header: {
          title: 'ロールプレイフィードバック',
          iconAlt: 'ロールプレイフィードバックアイコン',
        },
        errors: {
          transcriptAnalysis: '会話記録分析を取得できませんでした。',
          skillsAssessment: 'スキル評価を取得できませんでした。',
          summary: '要約を取得できませんでした。',
        },
        modal: {
          title: 'このセッションのロールプレイ分析は利用できません',
          description:
            '会話が短すぎて分析できませんでした。より長いセッションを完了して、強み、改善領域、スキル評価などの詳細なレポートをアンロックしてください！',
          imageAlt: '分析レポートプレビュー',
          closeButton: '閉じる',
          metrics: {
            activeCommunication: '積極的なコミュニケーション',
            conflictResolution: '紛争解決',
            empathy: '共感',
            goalSetting: '目標設定',
          },
        },
      },
    },
  },
  tl: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'Suporta sa Pagbebenta',
          handlingGuide: 'Gabay sa Paghawak',
          competitiveIntelligence: 'Competitive Intelligence',
          objectionHandlingGuide: 'Gabay sa Paghawak ng Tutol',
          responseSuggestions: 'Mga Mungkahing Tugon',
          contextualSuggestions: 'Mga Mungkahing Kontekstual',
          profile: 'Profile',
          clientProfile: 'Profile ng Kliyente',
          keyFeatures: 'Mga Pangunahing Katangian',
          coreBusiness: 'Mga Pangunahing Negosyo',
          pricing: 'Pagpepresyo',
          practiceSession: 'Pagsasanay',
        },
        errors: {
          failedToLoadScenario: 'Hindi ma-load ang scenario. Pakisubukan ulit.',
          failedToStartSession: 'Hindi masimulan ang session ng pagsasanay',
          failedToGenerateFeedback:
            'Hindi ma-generate ang feedback. Pakisubukan ulit.',
          failedToGeneratePdf: 'Hindi ma-generate ang PDF',
        },
        buttons: {
          connecting: 'Kumokonekta...',
          endSession: 'Tapusin ang Session',
          startPractice: 'Simulan ang Pagsasanay',
          hide: 'Itago',
          show: 'Ipakita',
          copy: 'Kopyahin',
          unmark: 'Alisin ang Marka',
          markComplete: 'Markahan na Tapos',
          showRecentTips: 'Ipakita ang mga kamakailang tips',
          showAllTips: 'Ipakita ang lahat ng tips',
          listenToFeedback: 'Pakinggan ang Feedback',
          pauseFeedback: 'I-pause ang Feedback',
          downloadPdf: 'I-download ang PDF',
          generatePdf: 'I-generate ang PDF',
          practiceAgain: 'Mag-practice Muli',
        },
        conversation: {
          toggleClientDetails: 'I-toggle ang mga detalye ng kliyente',
          readyToPractice: 'Handa na para sa Pagsasanay',
          youWillBeSpeak: 'Makikipag-usap ka kay',
          personaDescription:
            'isang {{age}}-taong-gulang na {{occupation}}{{location}}',
          basedIn: ' na nakabase sa ',
          interested: 'interesado',
          inFinancialSolutions:
            'sa mga financial solutions ngunit nag-aalala tungkol sa',
          speakingWith:
            'Makikipag-usap ka kay <bold>{{name}}</bold>, isang {{age}}-taong-gulang na {{occupation}} na nakabase sa {{location}}.',
          speakingWithNoLocation:
            'Makikipag-usap ka kay <bold>{{name}}</bold>, isang {{age}}-taong-gulang na {{occupation}}.',
        },
        competitors: {
          yourProductAdvantages: 'Mga Pakinabang ng Inyong Produkto',
          details: 'mga detalye',
          type: 'Uri:',
          keyFeatures: 'Mga Pangunahing Katangian',
          theirStrengths: 'Kanilang mga Lakas',
          theirLimitations: 'Kanilang mga Limitasyon',
          positioningStrategy: 'Estratehiya sa Positioning',
        },
        feedback: {
          frameworkImplementation: 'Pagpapatupad ng Framework',
          examplesFromConversation: 'Mga halimbawa mula sa inyong pag-uusap',
          improvementTip: 'Tip para sa pagpapabuti',
          keyStrengths: 'Mga Pangunahing Lakas',
          noKeyStrengths:
            'Walang mga pangunahing lakas na napansin sa usapang ito.',
          noKeyStrengthsNoted: 'Walang mga pangunahing lakas na napansin.',
          areasForImprovement: 'Mga Lugar para sa Pagpapabuti',
          noAreasForImprovement:
            'Walang mga lugar para sa pagpapabuti na nakilala.',
          noAreasForImprovementNoted:
            'Walang mga lugar para sa pagpapabuti na napansin.',
          productKnowledge: 'Kaalaman sa Produkto',
          accuracyScore: 'Score sa Katumpakan:',
          strengths: 'Mga Lakas',
          noProductStrengths:
            'Walang mga lakas sa produkto na nakilala sa usapang ito.',
          noProductStrengthsNoted: 'Walang mga lakas sa produkto na napansin.',
          factualErrorsFirst:
            'Mga maling impormasyon una na may espesyal na styling',
          correct: 'Tama:',
          noProductKnowledgeGaps:
            'Walang mga kakulangan sa kaalaman sa produkto na nakilala.',
          noProductKnowledgeGapsNoted:
            'Walang mga kakulangan sa kaalaman sa produkto na napansin.',
          competitorComparisonHandling:
            'Paghawak ng Paghahambing sa Competitor',
          effectivePositioning: 'Epektibong Positioning',
          noEffectivePositioning:
            'Walang mga epektibong estratehiya sa positioning na nakilala.',
          noEffectivePositioningNoted:
            'Walang epektibong positioning na napansin.',
          improvementOpportunities: 'Mga Pagkakataong Pagpapabuti',
          noImprovementOpportunities:
            'Walang mga pagkakataong pagpapabuti na nakilala.',
          noImprovementOpportunitiesNoted:
            'Walang mga pagkakataong pagpapabuti na napansin.',
          missedPositioningOpportunities:
            'Mga Napalampas na Pagkakataong Positioning:',
          conversationHighlights: 'Mga Highlight ng Pag-uusap',
          bestPractices: 'Mga Pinakamahusay na Gawi',
          noBestPractices:
            'Walang mga pinakamahusay na gawi na nakilala sa usapang ito.',
          noBestPracticesNoted: 'Walang mga pinakamahusay na gawi na napansin.',
          missedOpportunities: 'Mga Napalampas na Pagkakataon',
          noMissedOpportunities:
            'Walang mga napalampas na pagkakataon na nakilala.',
          noMissedOpportunitiesNoted:
            'Walang mga napalampas na pagkakataon na napansin.',
          nextSteps: 'Mga Susunod na Hakbang',
          preparingFeedback: 'Naghahanda ng feedback...',
          reconnecting: 'Muling kumukonekta...',
          loadingAudio: 'Naglo-load ng audio...',
          generatingPdf: 'Nag-ge-generate ng PDF...',
          showRecentTips: 'Ipakita ang mga kamakailang tips',
          showAllTips: 'Ipakita ang lahat ng tips',
        },
        objectionHandling: {
          guide: 'Gabay sa Paghawak ng Tutol',
          primaryObjection: 'Pangunahing Tutol',
          suggestedResponse: 'Mungkahing Tugon 3F:',
          suggested3FsResponse: 'Mungkahing Tugon 3F',
          feel: 'Pakiramdam',
          feelText: 'Nauunawaan ko ang inyong pakiramdam tungkol sa',
          feelExample: 'Nauunawaan ko ang inyong pakiramdam tungkol sa',
          feelExampleOneSentence:
            'Nauunawaan ko ang inyong pakiramdam. Normal lang na nais ninyong maging malinaw bago gumawa ng desisyon.',
          commonConcern: 'Ito ay karaniwang alalahanin.',
          felt: 'Naramdaman',
          feltText:
            'Marami sa aking mga kliyente ay naramdaman din ang pareho nang pinag-iisipan nila ang ganitong uri ng produkto.',
          feltExample:
            'Marami sa aking mga kliyente ay naramdaman din ang pareho nang pinag-iisipan nila ang ganitong uri ng produkto.',
          found: 'Natuklasan',
          foundText:
            'Natuklasan nila na ang mga pangmatagalang benepisyo at proteksyon na inaalok ng aming produkto ay nagbibigay ng mahusay na halaga sa kabila ng mga paunang alalahanin.',
          foundExample:
            'Natuklasan nila na ang mga pangmatagalang benepisyo at proteksyon na inaalok ng aming produkto ay nagbibigay ng mahusay na halaga sa kabila ng mga paunang alalahanin.',
          secondaryObjections: 'Mga Pangalawang Tutol',
          framework: 'Framework',
          frameworkTitleTemplate: '{{name}} Framework',
          watchFor: 'Bantayan',
        },
        suggestions: {
          responseSuggestions: 'Mga Mungkahing Tugon',
          understandConcern:
            'Lubos kong nauunawaan ang inyong alalahanin sa buwanang premium.',
          naturalToFeel:
            'Natural lamang na mag-atubili sa ganitong financial commitment.',
          appreciateOpenness:
            'Pinasasalamatan ko na naging bukas kayo tungkol sa mga considerasyon sa budget.',
          clientsFeltSame:
            'Marami sa aming mga kliyente ay may parehong pakiramdam sa gastos noong una.',
          workedWithSimilar:
            'Kamakailan ay nagtrabaho ako sa isang taong may kaparehong sitwasyon na may parehong mga alalahanin.',
          remindsMe:
            'Naaalala ko ang isa pang kliyente na nag-alala din sa mga premium.',
          foundBenefits:
            'Natuklasan nila na ang pangmatagalang mga benepisyo ay mas nakakatalo pa sa buwanang puhunan.',
          discoveredWaiting:
            'Ang natuklasan nila ay ang paghihintay ay magdudulot ng mas malaking gastos.',
          foundPeaceOfMind:
            'Sa huli, natuklasan nila na ang kapayapaan ng isip ay sulit ang pagkakahulugan.',
        },
        objectives: {
          title: 'Mga layunin ng roleplay session',
          sessionObjectives: 'Mga layunin ng roleplay session',
          acknowledgePriceConcern: 'Kilalanin ang alalahanin sa presyo',
          shareRelevantExperience: 'Ibahagi ang kaugnay na karanasan',
          demonstrateValueProposition: 'Ipakita ang value proposition',
          addressSpecificObjections: 'Tugunan ang mga tukoy na tutol',
          moveTowardsCommitment: 'Magtungo sa commitment',
        },
        persona: {
          background: 'Pinagmulan',
          profile: 'Profile',
          style: 'Istilo',
          nameAndDemographics: 'Pangalan at Demographics',
          occupation: 'Trabaho',
          annualIncome: 'Kita Taun-taon',
          education: 'Edukasyon',
          location: 'Lokasyon',
          clientBackground: 'Background ng Kliyente',
          workHistory: 'Kasaysayan ng Trabaho',
          financialSituation: 'Sitwasyon sa Pananalapi',
          productKnowledge: 'Kaalaman sa Produkto',
          keyPriorities: 'Mga Pangunahing Priyoridad',
          communicationStyle: 'Istilo ng Komunikasyon',
          personalityTraits: 'Mga Katangian ng Personalidad',
          decisionMaking: 'Paggawa ng Desisyon',
          male: 'Lalaki',
          female: 'Babae',
          year: 'taon',
        },
        mobile: {
          conversation: 'Pag-uusap',
          salesInfo: 'Impormasyon sa Pagbebenta',
          guide: 'Gabay',
        },
        transcript: {
          title: 'Talaan',
          description: 'Kumpletong talaan ng iyong practice session',
        },
        report: {
          tabs: {
            summary: 'Buod',
            skillsAssessment: 'Pagtatasa ng Kakayahan',
            transcriptAnalysis: 'Pagsusuri ng Talaan',
          },
          header: {
            title: 'Puna sa roleplay',
            iconAlt: 'Icon ng puna sa roleplay',
          },
          errors: {
            transcriptAnalysis: 'Hindi makuha ang pagsusuri ng talaan.',
            skillsAssessment: 'Hindi makuha ang pagtatasa ng kakayahan.',
            summary: 'Hindi makuha ang buod.',
          },
          modal: {
            title:
              'Hindi available ang pagsusuri ng roleplay para sa session na ito',
            description:
              'Sobrang ikli ng inyong pag-uusap para masuri. Tapusin ang mas mahabang session upang ma-unlock ang detalyadong ulat tungkol sa mga lakas, mga lugar na mapapabuti, pagtatasa ng kakayahan, at marami pang iba!',
            imageAlt: 'Preview ng Ulat ng Pagsusuri',
            closeButton: 'Isara',
            metrics: {
              activeCommunication: 'Aktibong Komunikasyon',
              conflictResolution: 'Paglutas ng Alitan',
              empathy: 'Pakikipagkunware',
              goalSetting: 'Pagtakda ng Layunin',
            },
          },
        },
      },
    },
  },
  vi: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'Hỗ Trợ Bán Hàng',
          handlingGuide: 'Hướng Dẫn Xử Lý',
          competitiveIntelligence: 'Thông Tin Cạnh Tranh',
          objectionHandlingGuide: 'Hướng Dẫn Xử Lý Phản Đối',
          responseSuggestions: 'Đề Xuất Phản Hồi',
          contextualSuggestions: 'Đề Xuất Theo Ngữ Cảnh',
          profile: 'Hồ Sơ',
          clientProfile: 'Hồ Sơ Khách Hàng',
          keyFeatures: 'Tính Năng Chính',
          coreBusiness: 'Hoạt Động Kinh Doanh Cốt Lõi',
          pricing: 'Giá Cả',
          practiceSession: 'Thực Hành',
        },
        errors: {
          failedToLoadScenario: 'Không thể tải kịch bản. Vui lòng thử lại.',
          failedToStartSession: 'Không thể bắt đầu phiên thực hành',
          failedToGenerateFeedback: 'Không thể tạo phản hồi. Vui lòng thử lại.',
          failedToGeneratePdf: 'Không thể tạo PDF',
        },
        buttons: {
          connecting: 'Đang kết nối...',
          endSession: 'Kết Thúc Phiên',
          startPractice: 'Bắt Đầu Thực Hành',
          hide: 'Ẩn',
          show: 'Hiện',
          copy: 'Sao Chép',
          unmark: 'Bỏ Đánh Dấu',
          markComplete: 'Đánh Dấu Hoàn Thành',
          showRecentTips: 'Hiển thị gợi ý gần đây',
          showAllTips: 'Hiển thị tất cả gợi ý',
          listenToFeedback: 'Nghe Phản Hồi',
          pauseFeedback: 'Tạm Dừng Phản Hồi',
          downloadPdf: 'Tải Xuống PDF',
          generatePdf: 'Tạo PDF',
          practiceAgain: 'Thực Hành Lại',
        },
        conversation: {
          toggleClientDetails: 'Bật/tắt chi tiết khách hàng',
          readyToPractice: 'Sẵn Sàng Thực Hành',
          youWillBeSpeak: 'Bạn sẽ nói chuyện với',
          personaDescription: 'một {{occupation}} {{age}} tuổi{{location}}',
          basedIn: ' đang sống tại ',
          interested: 'quan tâm',
          inFinancialSolutions: 'đến các giải pháp tài chính nhưng lo lắng về',
          speakingWith:
            'Bạn sẽ nói chuyện với <bold>{{name}}</bold>, một {{occupation}} {{age}} tuổi đang sống tại {{location}}.',
          speakingWithNoLocation:
            'Bạn sẽ nói chuyện với <bold>{{name}}</bold>, một {{occupation}} {{age}} tuổi.',
        },
        competitors: {
          yourProductAdvantages: 'Lợi Thế Sản Phẩm Của Bạn',
          details: 'chi tiết',
          type: 'Loại:',
          keyFeatures: 'Tính Năng Chính',
          theirStrengths: 'Điểm Mạnh Của Họ',
          theirLimitations: 'Hạn Chế Của Họ',
          positioningStrategy: 'Chiến Lược Định Vị',
        },
        feedback: {
          frameworkImplementation: 'Triển Khai Khung',
          examplesFromConversation: 'Ví dụ từ cuộc trò chuyện của bạn',
          improvementTip: 'Mẹo cải thiện',
          keyStrengths: 'Điểm Mạnh Chính',
          noKeyStrengths:
            'Không có điểm mạnh chính nào được ghi nhận trong cuộc trò chuyện này.',
          noKeyStrengthsNoted: 'Không có điểm mạnh chính nào được ghi nhận.',
          areasForImprovement: 'Khu Vực Cần Cải Thiện',
          noAreasForImprovement:
            'Không có khu vực cải thiện nào được xác định.',
          noAreasForImprovementNoted:
            'Không có khu vực cải thiện nào được ghi nhận.',
          productKnowledge: 'Kiến Thức Sản Phẩm',
          accuracyScore: 'Điểm Chính Xác:',
          strengths: 'Điểm Mạnh',
          noProductStrengths:
            'Không có điểm mạnh sản phẩm nào được xác định trong cuộc trò chuyện này.',
          noProductStrengthsNoted:
            'Không có điểm mạnh sản phẩm nào được ghi nhận.',
          factualErrorsFirst: 'Lỗi thực tế được ưu tiên với kiểu dáng đặc biệt',
          correct: 'Đúng:',
          noProductKnowledgeGaps:
            'Không có khoảng trống kiến thức sản phẩm nào được xác định.',
          noProductKnowledgeGapsNoted:
            'Không có khoảng trống kiến thức sản phẩm nào được ghi nhận.',
          competitorComparisonHandling: 'Xử Lý So Sánh Đối Thủ',
          effectivePositioning: 'Định Vị Hiệu Quả',
          noEffectivePositioning:
            'Không có chiến lược định vị hiệu quả nào được xác định.',
          noEffectivePositioningNoted:
            'Không có định vị hiệu quả nào được ghi nhận.',
          improvementOpportunities: 'Cơ Hội Cải Thiện',
          noImprovementOpportunities:
            'Không có cơ hội cải thiện nào được xác định.',
          noImprovementOpportunitiesNoted:
            'Không có cơ hội cải thiện nào được ghi nhận.',
          missedPositioningOpportunities: 'Cơ Hội Định Vị Bị Bỏ Lỡ:',
          conversationHighlights: 'Điểm Nổi Bật Cuộc Trò Chuyện',
          bestPractices: 'Thực Hành Tốt Nhất',
          noBestPractices:
            'Không có thực hành tốt nhất nào được xác định trong cuộc trò chuyện này.',
          noBestPracticesNoted:
            'Không có thực hành tốt nhất nào được ghi nhận.',
          missedOpportunities: 'Cơ Hội Bị Bỏ Lỡ',
          noMissedOpportunities: 'Không có cơ hội bị bỏ lỡ nào được xác định.',
          noMissedOpportunitiesNoted:
            'Không có cơ hội bị bỏ lỡ nào được ghi nhận.',
          nextSteps: 'Bước Tiếp Theo',
          preparingFeedback: 'Đang chuẩn bị phản hồi...',
          reconnecting: 'Đang kết nối lại...',
          loadingAudio: 'Đang tải âm thanh...',
          generatingPdf: 'Đang tạo PDF...',
          showRecentTips: 'Hiển thị gợi ý gần đây',
          showAllTips: 'Hiển thị tất cả gợi ý',
        },
        objectionHandling: {
          guide: 'Hướng Dẫn Xử Lý Phản Đối',
          primaryObjection: 'Phản Đối Chính',
          suggestedResponse: 'Phản Hồi 3F Được Đề Xuất:',
          suggested3FsResponse: 'Phản Hồi 3F Được Đề Xuất',
          feel: 'Cảm Nhận',
          feelText: 'Tôi hiểu cảm giác của bạn về',
          feelExample: 'Tôi hiểu cảm giác của bạn về',
          feelExampleOneSentence:
            'Tôi hiểu cảm giác của bạn. Hoàn toàn bình thường khi muốn có sự rõ ràng trước khi đưa ra quyết định.',
          commonConcern: 'Đây là mối quan tâm phổ biến.',
          felt: 'Đã Cảm Thấy',
          feltText:
            'Nhiều khách hàng của tôi cũng cảm thấy như vậy khi họ đang xem xét loại sản phẩm này.',
          feltExample:
            'Nhiều khách hàng của tôi cũng cảm thấy như vậy khi họ đang xem xét loại sản phẩm này.',
          found: 'Đã Phát Hiện',
          foundText:
            'Họ phát hiện ra rằng các lợi ích dài hạn và sự bảo vệ do sản phẩm của chúng tôi cung cấp thực sự mang lại giá trị tuyệt vời bất chấp những lo ngại ban đầu.',
          foundExample:
            'Họ phát hiện ra rằng các lợi ích dài hạn và sự bảo vệ do sản phẩm của chúng tôi cung cấp thực sự mang lại giá trị tuyệt vời bất chấp những lo ngại ban đầu.',
          secondaryObjections: 'Phản Đối Thứ Yếu',
          framework: 'Khung',
          frameworkTitleTemplate: '{{name}} Khung',
          watchFor: 'Chú Ý',
        },
        suggestions: {
          responseSuggestions: 'Đề Xuất Phản Hồi',
          understandConcern:
            'Tôi hoàn toàn hiểu mối quan tâm của bạn về phí hàng tháng.',
          naturalToFeel:
            'Việc cảm thấy do dự về cam kết tài chính này là điều tự nhiên.',
          appreciateOpenness:
            'Tôi đánh giá cao sự cởi mở của bạn về các cân nhắc ngân sách.',
          clientsFeltSame:
            'Nhiều khách hàng của tôi ban đầu cũng cảm thấy như vậy về chi phí.',
          workedWithSimilar:
            'Gần đây tôi đã làm việc với một người trong tình huống tương tự có cùng mối quan tâm.',
          remindsMe:
            'Điều này nhắc tôi nhớ về một khách hàng khác cũng lo lắng về phí bảo hiểm.',
          foundBenefits:
            'Họ phát hiện ra rằng các lợi ích dài hạn vượt xa khoản đầu tư hàng tháng.',
          discoveredWaiting:
            'Điều họ khám phá ra là việc chờ đợi thực sự sẽ tốn nhiều chi phí hơn.',
          foundPeaceOfMind:
            'Cuối cùng, họ thấy rằng sự an tâm là đáng giá với khoản đầu tư.',
        },
        objectives: {
          title: 'Mục tiêu phiên đóng vai',
          sessionObjectives: 'Mục tiêu phiên đóng vai',
          acknowledgePriceConcern: 'Thừa nhận mối quan tâm về giá',
          shareRelevantExperience: 'Chia sẻ kinh nghiệm liên quan',
          demonstrateValueProposition: 'Chứng minh đề xuất giá trị',
          addressSpecificObjections: 'Giải quyết các phản đối cụ thể',
          moveTowardsCommitment: 'Tiến tới cam kết',
        },
        persona: {
          background: 'Bối Cảnh',
          profile: 'Hồ Sơ',
          style: 'Phong Cách',
          nameAndDemographics: 'Tên & Nhân Khẩu Học',
          occupation: 'Nghề Nghiệp',
          annualIncome: 'Thu Nhập Hàng Năm',
          education: 'Học Vấn',
          location: 'Địa Điểm',
          clientBackground: 'Bối Cảnh Khách Hàng',
          workHistory: 'Lịch Sử Công Việc',
          financialSituation: 'Tình Hình Tài Chính',
          productKnowledge: 'Kiến Thức Sản Phẩm',
          keyPriorities: 'Ưu Tiên Chính',
          communicationStyle: 'Phong Cách Giao Tiếp',
          personalityTraits: 'Đặc Điểm Tính Cách',
          decisionMaking: 'Ra Quyết Định',
          male: 'Nam',
          female: 'Nữ',
          year: 'năm',
        },
        mobile: {
          conversation: 'Cuộc Trò Chuyện',
          salesInfo: 'Thông Tin Bán Hàng',
          guide: 'Hướng Dẫn',
        },
        transcript: {
          title: 'Bản Ghi',
          description: 'Bản ghi đầy đủ của phiên thực hành của bạn',
        },
        report: {
          tabs: {
            summary: 'Tóm Tắt',
            skillsAssessment: 'Đánh Giá Kỹ Năng',
            transcriptAnalysis: 'Phân Tích Bản Ghi',
          },
          header: {
            title: 'Phản hồi đóng vai',
            iconAlt: 'Biểu tượng phản hồi đóng vai',
          },
          errors: {
            transcriptAnalysis: 'Không thể lấy phân tích bản ghi.',
            skillsAssessment: 'Không thể lấy đánh giá kỹ năng.',
            summary: 'Không thể lấy tóm tắt.',
          },
          modal: {
            title: 'Phân tích đóng vai không khả dụng cho phiên này',
            description:
              'Cuộc trò chuyện của bạn quá ngắn để phân tích. Hoàn thành một phiên dài hơn để mở khóa báo cáo chi tiết về điểm mạnh, lĩnh vực cần cải thiện, đánh giá kỹ năng và nhiều hơn nữa!',
            imageAlt: 'Xem Trước Báo Cáo Phân Tích',
            closeButton: 'Đóng',
            metrics: {
              activeCommunication: 'Giao Tiếp Tích Cực',
              conflictResolution: 'Giải Quyết Xung Đột',
              empathy: 'Đồng Cảm',
              goalSetting: 'Đặt Mục Tiêu',
            },
          },
        },
      },
      feedback: {
        tabs: {
          summary: 'Tóm Tắt',
          skillsAssessment: 'Đánh giá kỹ năng',
          transcriptAnalysis: 'Phân tích bản ghi',
        },
        header: {
          title: 'Phản hồi đóng vai',
          iconAlt: 'Biểu tượng phản hồi đóng vai',
        },
        errors: {
          transcriptAnalysis: 'Không thể lấy phân tích bản ghi.',
          skillsAssessment: 'Không thể lấy đánh giá kỹ năng.',
          summary: 'Không thể lấy tóm tắt.',
        },
        modal: {
          title: 'Phân tích đóng vai không khả dụng cho phiên này',
          description:
            'Cuộc trò chuyện của bạn quá ngắn để phân tích. Hoàn thành một phiên dài hơn để mở khóa báo cáo chi tiết về điểm mạnh, lĩnh vực cần cải thiện, đánh giá kỹ năng và nhiều hơn nữa!',
          imageAlt: 'Xem Trước Báo Cáo Phân Tích',
          closeButton: 'Đóng',
          metrics: {
            activeCommunication: 'Giao tiếp tích cực',
            conflictResolution: 'Giải quyết xung đột',
            empathy: 'Đồng cảm',
            goalSetting: 'Đặt mục tiêu',
          },
        },
      },
    },
  },
  ms: {
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'Sokongan Jualan',
          handlingGuide: 'Panduan Pengendalian',
          competitiveIntelligence: 'Kepintaran Kompetitif',
          objectionHandlingGuide: 'Panduan Mengendalikan Bantahan',
          responseSuggestions: 'Cadangan Respons',
          contextualSuggestions: 'Cadangan Kontekstual',
          profile: 'Profil',
          clientProfile: 'Profil Klien',
          keyFeatures: 'Ciri Utama',
          coreBusiness: 'Perniagaan Teras',
          pricing: 'Harga',
          practiceSession: 'Latihan',
        },
        errors: {
          failedToLoadScenario: 'Gagal memuatkan senario. Sila cuba lagi.',
          failedToStartSession: 'Gagal memulakan sesi latihan',
          failedToGenerateFeedback:
            'Gagal menjana maklum balas. Sila cuba lagi.',
          failedToGeneratePdf: 'Gagal menjana PDF',
        },
        buttons: {
          connecting: 'Menyambung...',
          endSession: 'Tamatkan Sesi',
          startPractice: 'Mulakan Latihan',
          hide: 'Sembunyikan',
          show: 'Paparkan',
          copy: 'Salin',
          unmark: 'Buang Tanda',
          markComplete: 'Tandakan Selesai',
          showRecentTips: 'Paparkan petua terkini',
          showAllTips: 'Paparkan semua petua',
          listenToFeedback: 'Dengar Maklum Balas',
          pauseFeedback: 'Jeda Maklum Balas',
          downloadPdf: 'Muat Turun PDF',
          generatePdf: 'Jana PDF',
          practiceAgain: 'Latihan Lagi',
        },
        conversation: {
          toggleClientDetails: 'Togol butiran klien',
          readyToPractice: 'Bersedia Berlatih',
          youWillBeSpeak: 'Anda akan bercakap dengan',
          personaDescription:
            'seorang {{occupation}} berusia {{age}} tahun{{location}}',
          basedIn: ' yang berpangkalan di ',
          interested: 'berminat',
          inFinancialSolutions:
            'dalam penyelesaian kewangan tetapi bimbang tentang',
          speakingWith:
            'Anda akan bercakap dengan <bold>{{name}}</bold>, seorang {{occupation}} berusia {{age}} tahun yang berpangkalan di {{location}}.',
          speakingWithNoLocation:
            'Anda akan bercakap dengan <bold>{{name}}</bold>, seorang {{occupation}} berusia {{age}} tahun.',
        },
        competitors: {
          yourProductAdvantages: 'Kelebihan Produk Anda',
          details: 'butiran',
          type: 'Jenis:',
          keyFeatures: 'Ciri Utama',
          theirStrengths: 'Kekuatan Mereka',
          theirLimitations: 'Batasan Mereka',
          positioningStrategy: 'Strategi Kedudukan',
        },
        feedback: {
          frameworkImplementation: 'Pelaksanaan Kerangka',
          examplesFromConversation: 'Contoh dari perbualan anda',
          improvementTip: 'Petua penambahbaikan',
          keyStrengths: 'Kekuatan Utama',
          noKeyStrengths:
            'Tiada kekuatan utama yang dikenal pasti dalam perbualan ini.',
          noKeyStrengthsNoted: 'Tiada kekuatan utama yang dicatatkan.',
          areasForImprovement: 'Bidang untuk Penambahbaikan',
          noAreasForImprovement:
            'Tiada bidang penambahbaikan yang dikenal pasti.',
          noAreasForImprovementNoted:
            'Tiada bidang penambahbaikan yang dicatatkan.',
          productKnowledge: 'Pengetahuan Produk',
          accuracyScore: 'Skor Ketepatan:',
          strengths: 'Kekuatan',
          noProductStrengths:
            'Tiada kekuatan produk yang dikenal pasti dalam perbualan ini.',
          noProductStrengthsNoted: 'Tiada kekuatan produk yang dicatatkan.',
          factualErrorsFirst: 'Kesilapan fakta dipaparkan dahulu',
          correct: 'Betul:',
          noProductKnowledgeGaps:
            'Tiada jurang pengetahuan produk yang dikenal pasti.',
          noProductKnowledgeGapsNoted:
            'Tiada jurang pengetahuan produk yang dicatatkan.',
          competitorComparisonHandling: 'Pengendalian Perbandingan Pesaing',
          effectivePositioning: 'Kedudukan Berkesan',
          noEffectivePositioning:
            'Tiada strategi kedudukan berkesan yang dikenal pasti.',
          noEffectivePositioningNoted:
            'Tiada kedudukan berkesan yang dicatatkan.',
          improvementOpportunities: 'Peluang Penambahbaikan',
          noImprovementOpportunities:
            'Tiada peluang penambahbaikan yang dikenal pasti.',
          noImprovementOpportunitiesNoted:
            'Tiada peluang penambahbaikan yang dicatatkan.',
          missedPositioningOpportunities: 'Peluang Kedudukan yang Terlepas:',
          conversationHighlights: 'Sorotan Perbualan',
          bestPractices: 'Amalan Terbaik',
          noBestPractices:
            'Tiada amalan terbaik yang dikenal pasti dalam perbualan ini.',
          noBestPracticesNoted: 'Tiada amalan terbaik yang dicatatkan.',
          missedOpportunities: 'Peluang yang Terlepas',
          noMissedOpportunities:
            'Tiada peluang yang terlepas yang dikenal pasti.',
          noMissedOpportunitiesNoted:
            'Tiada peluang yang terlepas yang dicatatkan.',
          nextSteps: 'Langkah Seterusnya',
          preparingFeedback: 'Menyediakan maklum balas...',
          reconnecting: 'Menyambung semula...',
          loadingAudio: 'Memuatkan audio...',
          generatingPdf: 'Menjana PDF...',
          showRecentTips: 'Paparkan petua terkini',
          showAllTips: 'Paparkan semua petua',
        },
        objectionHandling: {
          guide: 'Panduan Mengendalikan Bantahan',
          primaryObjection: 'Bantahan Utama',
          suggestedResponse: 'Respons 3F yang Dicadangkan:',
          suggested3FsResponse: 'Respons 3F yang Dicadangkan',
          feel: 'Rasa',
          feelText: 'Saya memahami perasaan anda tentang',
          feelExample: 'Saya memahami perasaan anda tentang',
          feelExampleOneSentence:
            'Saya memahami perasaan anda. Ia adalah perkara biasa untuk mahukan kejelasan sebelum membuat keputusan.',
          commonConcern: 'Ini adalah kebimbangan yang biasa.',
          felt: 'Merasakan',
          feltText:
            'Ramai klien saya merasakan perkara yang sama ketika mereka mempertimbangkan jenis produk ini.',
          feltExample:
            'Ramai klien saya merasakan perkara yang sama ketika mereka mempertimbangkan jenis produk ini.',
          found: 'Menemui',
          foundText:
            'Mereka menemui bahawa manfaat jangka panjang dan perlindungan yang ditawarkan produk kami sebenarnya memberikan nilai yang sangat baik walaupun ada kebimbangan awal.',
          foundExample:
            'Mereka menemui bahawa manfaat jangka panjang dan perlindungan yang ditawarkan produk kami sebenarnya memberikan nilai yang sangat baik walaupun ada kebimbangan awal.',
          secondaryObjections: 'Bantahan Sekunder',
          framework: 'Kerangka',
          frameworkTitleTemplate: 'Garis Panduan {{name}}',
          watchFor: 'Perhatikan',
        },
        suggestions: {
          responseSuggestions: 'Cadangan Respons',
          understandConcern:
            'Saya sangat memahami kebimbangan anda tentang premium bulanan.',
          naturalToFeel:
            'Adalah wajar untuk berasa ragu tentang komitmen kewangan ini.',
          appreciateOpenness:
            'Saya menghargai keterbukaan anda tentang pertimbangan bajet.',
          clientsFeltSame:
            'Ramai klien saya pada mulanya mempunyai perasaan yang sama tentang kos.',
          workedWithSimilar:
            'Saya baru-baru ini bekerja dengan seseorang dalam situasi yang serupa yang mempunyai kebimbangan yang sama.',
          remindsMe:
            'Ini mengingatkan saya kepada klien lain yang juga bimbang tentang premium.',
          foundBenefits:
            'Mereka menemui bahawa manfaat jangka panjang jauh melebihi pelaburan bulanan.',
          discoveredWaiting:
            'Yang mereka temui ialah menunggu sebenarnya akan menghabiskan kos lebih banyak.',
          foundPeaceOfMind:
            'Pada akhirnya, mereka menemui ketenangan fikiran berbaloi untuk dilaburkan.',
        },
        objectives: {
          title: 'Objektif sesi lakonan peranan',
          sessionObjectives: 'Objektif sesi lakonan peranan',
          acknowledgePriceConcern: 'Mengakui kebimbangan harga',
          shareRelevantExperience: 'Berkongsi pengalaman yang relevan',
          demonstrateValueProposition: 'Mendemonstrasikan proposisi nilai',
          addressSpecificObjections: 'Menangani bantahan spesifik',
          moveTowardsCommitment: 'Bergerak ke arah komitmen',
        },
        persona: {
          background: 'Latar Belakang',
          profile: 'Profil',
          style: 'Gaya',
          nameAndDemographics: 'Nama & Demografi',
          occupation: 'Pekerjaan',
          annualIncome: 'Pendapatan Tahunan',
          education: 'Pendidikan',
          location: 'Lokasi',
          clientBackground: 'Latar Belakang Klien',
          workHistory: 'Sejarah Pekerjaan',
          financialSituation: 'Situasi Kewangan',
          productKnowledge: 'Pengetahuan Produk',
          keyPriorities: 'Keutamaan Utama',
          communicationStyle: 'Gaya Komunikasi',
          personalityTraits: 'Ciri Keperibadian',
          decisionMaking: 'Pembuatan Keputusan',
          male: 'Lelaki',
          female: 'Perempuan',
          year: 'tahun',
        },
        mobile: {
          conversation: 'Perbualan',
          salesInfo: 'Maklumat Jualan',
          guide: 'Panduan',
        },
        transcript: {
          title: 'Transkrip',
          description: 'Transkrip lengkap sesi latihan anda',
        },
      },
      feedback: {
        tabs: {
          summary: 'Ringkasan',
          skillsAssessment: 'Penilaian kemahiran',
          transcriptAnalysis: 'Analisis transkrip',
        },
        header: {
          title: 'Maklum balas lakonan peranan',
          iconAlt: 'Ikon maklum balas lakonan peranan',
        },
        errors: {
          transcriptAnalysis: 'Tidak dapat mengambil analisis transkrip.',
          skillsAssessment: 'Tidak dapat mengambil penilaian kemahiran.',
          summary: 'Tidak dapat mengambil ringkasan.',
        },
        modal: {
          title: 'Analisis lakonan peranan tidak tersedia untuk sesi ini',
          description:
            'Perbualan anda terlalu ringkas untuk dianalisis. Selesaikan sesi yang lebih panjang untuk membuka laporan terperinci tentang kekuatan, bidang penambahbaikan, penilaian kemahiran, dan banyak lagi!',
          imageAlt: 'Pratonton Laporan Analisis',
          closeButton: 'Tutup',
          metrics: {
            activeCommunication: 'Komunikasi aktif',
            conflictResolution: 'Penyelesaian konflik',
            empathy: 'Empati',
            goalSetting: 'Penetapan matlamat',
          },
        },
      },
    },
  },
  sw: {
    insurance: {
      title: 'Mazoezi ya Uuzaji wa Bima',
      recommendedProducts: 'Bidhaa Zinazopendekezwa',
      conversation: 'Mazungumzo',
      startPractice: 'Anza Mazoezi',
      endSession: 'Maliza Kikao',
      loading: 'Inapakia...',
      connecting: 'Inaunganisha...',
      relevance: 'Uhusiano',
      monthlyPremium: 'Ada ya Kila Mwezi',
      coverage: 'Ufunikaji',
      keyFeatures: 'Vipengele Muhimu',
      viewDetails: 'Tazama Maelezo',
      hideDetails: 'Ficha Maelezo',
      listeningToClient: 'Mteja anaongea...',
      readyToStart: 'Tayari Kuanza',
      clientInfo: 'Taarifa za Mteja',
      mainConcerns: 'Mambo Muhimu',
      clientProfile: {
        basicInfo: 'Taarifa za Msingi',
        name: 'Jina',
        age: 'Umri',
        occupation: 'Kazi',
        family: 'Familia',
        married: 'Ameoa/Ameolewa',
        children: 'Watoto',
        financial: 'Hali ya Fedha',
        concerns: 'Mambo Muhimu',
        goals: 'Malengo',
        existingCoverage: 'Ufunikaji Uliopo',
      },
      products: {
        emptyStateTitle: 'Mapendekezo ya Bidhaa',
        emptyStateMessage:
          'Mapendekezo yataonekana unapo jadili mahitaji ya mteja',
        emptyStateSubtext: 'Bidhaa husasishwa papo hapo wakati wa mazungumzo',
        updatingRecommendations: 'Inasasisha mapendekezo...',
        topRecommendations: 'Bidhaa Zinazopendekezwa',
        showing: 'Inaonyesha',
        products: 'bidhaa',
      },
      feedback: {
        preparingFeedback: 'Inatayarisha mrejesho...',
        overallScore: 'Alama ya Jumla',
        strengths: 'Nguvu',
        improvements: 'Maeneo ya Kuboresha',
        productAnalysis: 'Uchambuzi wa Mapendekezo ya Bidhaa',
        conversationFlow: 'Mtitiriko wa Mazungumzo',
        nextSteps: 'Hatua Zifuatazo',
        practiceAgain: 'Fanya Mazoezi Tena',
      },
    },
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'Msaada wa Mauzo',
          handlingGuide: 'Mwongozo wa Kushughulikia',
          competitiveIntelligence: 'Ujasusi wa Ushindani',
          objectionHandlingGuide: 'Mwongozo wa Kushughulikia Pingamizi',
          responseSuggestions: 'Mapendekezo ya Majibu',
          contextualSuggestions: 'Mapendekezo ya Muktadha',
          profile: 'Profaili',
          clientProfile: 'Profaili ya Mteja',
          keyFeatures: 'Vipengele Muhimu',
          coreBusiness: 'Biashara Kuu',
          pricing: 'Bei',
          practiceSession: 'Mazoezi',
        },
        errors: {
          failedToLoadScenario:
            'Imeshindwa kupakia tukio. Tafadhali jaribu tena.',
          failedToStartSession: 'Imeshindwa kuanza kikao cha mazoezi',
          failedToGenerateFeedback:
            'Imeshindwa kutengeneza mrejesho. Tafadhali jaribu tena.',
          failedToGeneratePdf: 'Imeshindwa kutengeneza PDF',
        },
        buttons: {
          connecting: 'Inaunganisha...',
          endSession: 'Maliza Kikao',
          startPractice: 'Anza Mazoezi',
          hide: 'Ficha',
          show: 'Onyesha',
          copy: 'Nakili',
          unmark: 'Ondoa Alama',
          markComplete: 'Weka Kama Imekamilika',
          showRecentTips: 'Onyesha vidokezo vya hivi karibuni',
          showAllTips: 'Onyesha vidokezo vyote',
          listenToFeedback: 'Sikiliza Mrejesho',
          pauseFeedback: 'Sitisha Mrejesho',
          downloadPdf: 'Pakua PDF',
          generatePdf: 'Tengeneza PDF',
          practiceAgain: 'Fanya Mazoezi Tena',
        },
        conversation: {
          toggleClientDetails: 'Badilisha maelezo ya mteja',
          readyToPractice: 'Tayari kwa Mazoezi',
          youWillBeSpeak: 'Utaongea na',
          personaDescription:
            'mteja {{occupation}} mwenye umri wa miaka {{age}}{{location}}',
          basedIn: ' anayeishi ',
          interested: 'anapendezwa',
          inFinancialSolutions:
            'na suluhisho za kifedha lakini ana wasiwasi kuhusu',
          speakingWith:
            'Utaongea na <bold>{{name}}</bold>, mteja {{occupation}} mwenye umri wa miaka {{age}} anayeishi {{location}}.',
          speakingWithNoLocation:
            'Utaongea na <bold>{{name}}</bold>, mteja {{occupation}} mwenye umri wa miaka {{age}}.',
        },
        competitors: {
          yourProductAdvantages: 'Faida za Bidhaa Yako',
          details: 'maelezo',
          type: 'Aina:',
          keyFeatures: 'Vipengele Muhimu',
          theirStrengths: 'Nguvu Zao',
          theirLimitations: 'Mapungufu Yao',
          positioningStrategy: 'Mkakati wa Uwekaji Soko',
        },
        feedback: {
          frameworkImplementation: 'Utekelezaji wa Mfumo',
          examplesFromConversation: 'Mifano kutoka kwenye mazungumzo',
          improvementTip: 'Kidokezo cha kuboresha',
          keyStrengths: 'Nguvu Kuu',
          noKeyStrengths:
            'Hakuna nguvu kuu zilizobainishwa katika mazungumzo haya.',
          noKeyStrengthsNoted: 'Hakuna nguvu kuu zilizorekodiwa.',
          areasForImprovement: 'Maeneo ya Kuboresha',
          noAreasForImprovement: 'Hakuna maeneo ya kuboresha yaliyobainishwa.',
          noAreasForImprovementNoted:
            'Hakuna maeneo ya kuboresha yaliyorekodiwa.',
          productKnowledge: 'Ujuzi wa Bidhaa',
          accuracyScore: 'Alama ya Usahihi:',
          strengths: 'Nguvu',
          noProductStrengths:
            'Hakuna nguvu za bidhaa zilizobainishwa katika mazungumzo haya.',
          noProductStrengthsNoted: 'Hakuna nguvu za bidhaa zilizorekodiwa.',
          factualErrorsFirst: 'Makosa ya ukweli yanaonyeshwa kwanza',
          correct: 'Sahihi:',
          noProductKnowledgeGaps:
            'Hakuna mapengo ya ujuzi wa bidhaa yaliyobainishwa.',
          noProductKnowledgeGapsNoted:
            'Hakuna mapengo ya ujuzi wa bidhaa yaliyorekodiwa.',
          competitorComparisonHandling:
            'Ushughulikiaji wa Ulinganisho wa Washindani',
          effectivePositioning: 'Uwekaji Soko Ufanisi',
          noEffectivePositioning:
            'Hakuna mikakati bora ya uwekaji soko iliyobainishwa.',
          noEffectivePositioningNoted:
            'Hakuna uwekaji soko ufanisi uliorekodiwa.',
          improvementOpportunities: 'Fursa za Kuboresha',
          noImprovementOpportunities:
            'Hakuna fursa za kuboresha zilizobainishwa.',
          noImprovementOpportunitiesNoted:
            'Hakuna fursa za kuboresha zilizorekodiwa.',
          missedPositioningOpportunities: 'Fursa za uwekaji soko zilizokosa:',
          conversationHighlights: 'Sehemu Muhimu za Mazungumzo',
          bestPractices: 'Mikakati Bora',
          noBestPractices:
            'Hakuna mikakati bora iliyobainishwa katika mazungumzo haya.',
          noBestPracticesNoted: 'Hakuna mikakati bora iliyorekodiwa.',
          missedOpportunities: 'Fursa Zilizokosa',
          noMissedOpportunities: 'Hakuna fursa zilizokosa zilizobainishwa.',
          noMissedOpportunitiesNoted: 'Hakuna fursa zilizokosa zilizorekodiwa.',
          nextSteps: 'Hatua Zifuatazo',
          preparingFeedback: 'Inatayarisha mrejesho...',
          reconnecting: 'Inaunganisha tena...',
          loadingAudio: 'Inapakia sauti...',
          generatingPdf: 'Inatengeneza PDF...',
          showRecentTips: 'Onyesha vidokezo vya hivi karibuni',
          showAllTips: 'Onyesha vidokezo vyote',
        },
        objectionHandling: {
          guide: 'Mwongozo wa Kushughulikia Pingamizi',
          primaryObjection: 'Pingamizi Kuu',
          suggestedResponse: 'Jibu la 3F lililopendekezwa:',
          suggested3FsResponse: 'Jibu la 3F lililopendekezwa',
          feel: 'Hisia',
          feelText: 'Ninaelewa unavyohisi kuhusu',
          feelExample: 'Ninaelewa unavyohisi kuhusu',
          feelExampleOneSentence:
            'Ninaelewa unavyohisi. Ni kawaida kutaka uwazi kabla ya kufanya uamuzi.',
          commonConcern: 'Hili ni wasiwasi wa kawaida.',
          felt: 'Kuhisi',
          feltText:
            'Wateja wengi wangu walihisi vivyo hivyo walipokuwa wakizingatia aina hii ya bidhaa.',
          feltExample:
            'Wateja wengi wangu walihisi vivyo hivyo walipokuwa wakizingatia aina hii ya bidhaa.',
          found: 'Kupata',
          foundText:
            'Waligundua kuwa manufaa ya muda mrefu na ulinzi wa bidhaa yetu yalitoa thamani kubwa licha ya wasiwasi wa awali.',
          foundExample:
            'Waligundua kuwa manufaa ya muda mrefu na ulinzi wa bidhaa yetu yalitoa thamani kubwa licha ya wasiwasi wa awali.',
          secondaryObjections: 'Pingamizi za Ziada',
          framework: 'Mfumo',
          frameworkTitleTemplate: 'Mfumo wa {{name}}',
          watchFor: 'Angalia',
        },
        suggestions: {
          responseSuggestions: 'Mapendekezo ya Majibu',
          understandConcern:
            'Ninaelewa kabisa wasiwasi wako kuhusu ada ya kila mwezi.',
          naturalToFeel: 'Ni kawaida kusita kuhusu ahadi hii ya kifedha.',
          appreciateOpenness: 'Nathamini uwazi wako kuhusu bajeti.',
          clientsFeltSame:
            'Wateja wengi wangu mwanzoni walihisi vivyo hivyo kuhusu gharama.',
          workedWithSimilar:
            'Hivi karibuni nilifanya kazi na mtu katika hali sawa aliye na wasiwasi huo.',
          remindsMe:
            'Hii inanifanya nikumbuke mteja mwingine aliyekuwa na wasiwasi kuhusu malipo.',
          foundBenefits:
            'Waligundua kuwa manufaa ya muda mrefu yalizidi uwekezaji wa kila mwezi.',
          discoveredWaiting: 'Waligundua kwamba kusubiri kungegharimu zaidi.',
          foundPeaceOfMind:
            'Hatimaye walipata utulivu wa akili unaostahili uwekezaji.',
        },
        objectives: {
          title: 'Malengo ya kikao cha uigizaji',
          sessionObjectives: 'Malengo ya kikao cha uigizaji',
          acknowledgePriceConcern: 'Tambua wasiwasi wa bei',
          shareRelevantExperience: 'Shiriki uzoefu unaofaa',
          demonstrateValueProposition: 'Onyesha thamani ya pendekezo',
          addressSpecificObjections: 'Shughulikia pingamizi mahususi',
          moveTowardsCommitment: 'Sogea kuelekea kujitolea',
        },
        persona: {
          background: 'Historia',
          profile: 'Profaili',
          style: 'Mtindo',
          nameAndDemographics: 'Jina na Demografia',
          occupation: 'Kazi',
          annualIncome: 'Mapato ya Mwaka',
          education: 'Elimu',
          location: 'Mahali',
          clientBackground: 'Historia ya Mteja',
          workHistory: 'Historia ya Kazi',
          financialSituation: 'Hali ya Kifedha',
          productKnowledge: 'Ujuzi wa Bidhaa',
          keyPriorities: 'Vipaumbele Kuu',
          communicationStyle: 'Mtindo wa Mawasiliano',
          personalityTraits: 'Tabia za Utu',
          decisionMaking: 'Maamuzi',
          male: 'Mwanaume',
          female: 'Mwanamke',
          year: 'mwaka',
        },
        mobile: {
          conversation: 'Mazungumzo',
          salesInfo: 'Taarifa za Mauzo',
          guide: 'Mwongozo',
        },
        transcript: {
          title: 'Transkripti',
          description: 'Transkripti kamili ya kikao chako cha mazoezi',
        },
      },
      feedback: {
        tabs: {
          summary: 'Muhtasari',
          skillsAssessment: 'Tathmini ya ujuzi',
          transcriptAnalysis: 'Uchambuzi wa transkripti',
        },
        header: {
          title: 'Mrejesho wa uigizaji',
          iconAlt: 'Aikoni ya mrejesho wa uigizaji',
        },
        errors: {
          transcriptAnalysis: 'Haiwezekani kupata uchambuzi wa transkripti.',
          skillsAssessment: 'Haiwezekani kupata tathmini ya ujuzi.',
          summary: 'Haiwezekani kupata muhtasari.',
        },
        modal: {
          title: 'Uchambuzi wa uigizaji haupatikani kwa kikao hiki',
          description:
            'Mazungumzo yako ni mafupi sana kuchambua. Kamilisha kikao kirefu ili kufungua ripoti ya kina kuhusu nguvu, maeneo ya kuboresha, tathmini ya ujuzi, na zaidi!',
          imageAlt: 'Mwonekano wa Ripoti ya Uchambuzi',
          closeButton: 'Funga',
          metrics: {
            activeCommunication: 'Mawasiliano hai',
            conflictResolution: 'Utatuzi wa migogoro',
            empathy: 'Huruma',
            goalSetting: 'Uwekaji malengo',
          },
        },
      },
    },
  },
  ar: {
    insurance: {
      title: 'ممارسة مبيعات التأمين',
      recommendedProducts: 'المنتجات الموصى بها',
      conversation: 'المحادثة',
      startPractice: 'بدء التمرين',
      endSession: 'إنهاء الجلسة',
      loading: 'جاري التحميل...',
      connecting: 'جاري الاتصال...',
      relevance: 'الصلة',
      monthlyPremium: 'القسط الشهري',
      coverage: 'التغطية',
      keyFeatures: 'الميزات الرئيسية',
      viewDetails: 'عرض التفاصيل',
      hideDetails: 'إخفاء التفاصيل',
      listeningToClient: 'العميل يتحدث...',
      readyToStart: 'جاهز للبدء',
      clientInfo: 'معلومات العميل',
      mainConcerns: 'الاهتمامات الرئيسية',
      clientProfile: {
        basicInfo: 'المعلومات الأساسية',
        name: 'الاسم',
        age: 'العمر',
        occupation: 'المهنة',
        family: 'العائلة',
        married: 'متزوج',
        children: 'الأطفال',
        financial: 'الحالة المالية',
        concerns: 'الاهتمامات الرئيسية',
        goals: 'الأهداف',
        existingCoverage: 'التغطية الحالية',
      },
    },
    custom: {
      roleplay: {
        headers: {
          salesSupport: 'دعم المبيعات',
          handlingGuide: 'دليل المعالجة',
          competitiveIntelligence: 'الذكاء التنافسي',
          objectionHandlingGuide: 'دليل معالجة الاعتراضات',
          responseSuggestions: 'اقتراحات الرد',
          contextualSuggestions: 'اقتراحات سياقية',
          profile: 'الملف الشخصي',
          clientProfile: 'ملف العميل',
          keyFeatures: 'الميزات الرئيسية',
          coreBusiness: 'الأعمال الأساسية',
          pricing: 'التسعير',
          practiceSession: 'جلسة التمرين',
        },
        errors: {
          failedToLoadScenario: 'فشل تحميل السيناريو. يرجى المحاولة مرة أخرى.',
          failedToStartSession: 'فشل بدء جلسة التمرين',
          failedToGenerateFeedback:
            'فشل إنشاء التقييم. يرجى المحاولة مرة أخرى.',
          failedToGeneratePdf: 'فشل إنشاء ملف PDF',
        },
        buttons: {
          connecting: 'جاري الاتصال...',
          endSession: 'إنهاء الجلسة',
          startPractice: 'بدء التمرين',
          hide: 'إخفاء',
          show: 'عرض',
          copy: 'نسخ',
          unmark: 'إلغاء التحديد',
          markComplete: 'تحديد كمكتمل',
          showRecentTips: 'عرض النصائح الأخيرة',
          showAllTips: 'عرض جميع النصائح',
          listenToFeedback: 'الاستماع إلى التقييم',
          pauseFeedback: 'إيقاف التقييم مؤقتاً',
          downloadPdf: 'تنزيل PDF',
          generatePdf: 'إنشاء PDF',
          practiceAgain: 'التمرين مرة أخرى',
        },
        conversation: {
          toggleClientDetails: 'تبديل تفاصيل العميل',
          readyToPractice: 'جاهز للتمرين',
          youWillBeSpeak: 'ستتحدث مع',
          personaDescription:
            'شخص يبلغ من العمر {{age}} سنة يعمل {{occupation}}{{location}}',
          basedIn: ' مقيم في ',
          interested: 'مهتم',
          inFinancialSolutions: 'بالحلول المالية ولكن قلق بشأن',
          speakingWith:
            'ستتحدث مع <bold>{{name}}</bold>، شخص يبلغ من العمر {{age}} سنة يعمل {{occupation}} مقيم في {{location}}.',
          speakingWithNoLocation:
            'ستتحدث مع <bold>{{name}}</bold>، شخص يبلغ من العمر {{age}} سنة يعمل {{occupation}}.',
        },
        competitors: {
          yourProductAdvantages: 'مزايا منتجك',
          details: 'التفاصيل',
          type: 'النوع:',
          keyFeatures: 'الميزات الرئيسية',
          theirStrengths: 'نقاط قوتهم',
          theirLimitations: 'نقاط ضعفهم',
          positioningStrategy: 'استراتيجية التموضع',
        },
        feedback: {
          frameworkImplementation: 'تطبيق الإطار',
          examplesFromConversation: 'أمثلة من محادثتك',
          improvementTip: 'نصيحة للتحسين',
          keyStrengths: 'نقاط القوة الرئيسية',
          noKeyStrengths: 'لا توجد نقاط قوة رئيسية في هذه المحادثة.',
          noKeyStrengthsNoted: 'لا توجد نقاط قوة رئيسية مسجلة.',
          areasForImprovement: 'مجالات التحسين',
          noAreasForImprovement: 'لم يتم تحديد مجالات تحسين.',
          noAreasForImprovementNoted: 'لا توجد مجالات تحسين مسجلة.',
          productKnowledge: 'معرفة المنتج',
          accuracyScore: 'درجة الدقة:',
          strengths: 'نقاط القوة',
          noProductStrengths: 'لم يتم تحديد نقاط قوة للمنتج في هذه المحادثة.',
          noProductStrengthsNoted: 'لا توجد نقاط قوة للمنتج مسجلة.',
          factualErrorsFirst: 'الأخطاء الواقعية أولاً',
          correct: 'صحيح:',
          noProductKnowledgeGaps: 'لم يتم تحديد فجوات في معرفة المنتج.',
          noProductKnowledgeGapsNoted: 'لا توجد فجوات في معرفة المنتج مسجلة.',
          competitorComparisonHandling: 'معالجة المقارنة مع المنافسين',
          effectivePositioning: 'التموضع الفعال',
          noEffectivePositioning: 'لم يتم تحديد استراتيجيات تموضع فعالة.',
          noEffectivePositioningNoted: 'لا يوجد تموضع فعال مسجل.',
          improvementOpportunities: 'فرص التحسين',
          noImprovementOpportunities: 'لم يتم تحديد فرص تحسين.',
          noImprovementOpportunitiesNoted: 'لا توجد فرص تحسين مسجلة.',
          missedPositioningOpportunities: 'فرص التموضع الضائعة:',
          conversationHighlights: 'نقاط مهمة من المحادثة',
          bestPractices: 'أفضل الممارسات',
          noBestPractices: 'لم يتم تحديد أفضل ممارسات في هذه المحادثة.',
          noBestPracticesNoted: 'لا توجد أفضل ممارسات مسجلة.',
          missedOpportunities: 'الفرص الضائعة',
          noMissedOpportunities: 'لم يتم تحديد فرص ضائعة.',
          noMissedOpportunitiesNoted: 'لا توجد فرص ضائعة مسجلة.',
          nextSteps: 'الخطوات التالية',
          preparingFeedback: 'جاري إعداد التقييم...',
          reconnecting: 'جاري إعادة الاتصال...',
          loadingAudio: 'جاري تحميل الصوت...',
          generatingPdf: 'جاري إنشاء PDF...',
          showRecentTips: 'عرض النصائح الأخيرة',
          showAllTips: 'عرض جميع النصائح',
        },
        objectionHandling: {
          guide: 'دليل معالجة الاعتراضات',
          primaryObjection: 'الاعتراض الرئيسي',
          suggestedResponse: 'الرد المقترح بطريقة 3F:',
          suggested3FsResponse: 'الرد المقترح بطريقة 3F',
          feel: 'أشعر',
          feelText: 'أتفهم شعورك بـ',
          feelExample: 'أتفهم شعورك بـ',
          feelExampleOneSentence:
            'أتفهم مشاعرك. من الطبيعي أن ترغب في الوضوح قبل اتخاذ القرار.',
          commonConcern: 'هذا قلق شائع.',
          felt: 'شعر',
          feltText:
            'العديد من عملائي شعروا بنفس الشيء عند النظر في هذا النوع من المنتجات.',
          feltExample:
            'العديد من عملائي شعروا بنفس الشيء عند النظر في هذا النوع من المنتجات.',
          found: 'وجد',
          foundText:
            'وجدوا أن الفوائد طويلة الأجل والحماية التي يوفرها منتجنا تقدم قيمة ممتازة رغم المخاوف الأولية.',
          foundExample:
            'وجدوا أن الفوائد طويلة الأجل والحماية التي يوفرها منتجنا تقدم قيمة ممتازة رغم المخاوف الأولية.',
          secondaryObjections: 'الاعتراضات الثانوية',
          framework: 'الإطار',
          frameworkTitleTemplate: 'إرشادات {{name}}',
          watchFor: 'انتبه لـ',
        },
        suggestions: {
          responseSuggestions: 'اقتراحات الرد',
          understandConcern: 'أتفهم تماماً قلقك بشأن القسط الشهري.',
          naturalToFeel: 'من الطبيعي أن تشعر بالتردد بشأن هذا الالتزام المالي.',
          appreciateOpenness: 'أقدر صراحتك بشأن اعتبارات الميزانية.',
          clientsFeltSame:
            'العديد من عملائي شعروا بنفس الشيء في البداية بشأن التكلفة.',
          workedWithSimilar:
            'عملت مؤخراً مع شخص في موقف مماثل كان لديه نفس المخاوف.',
          remindsMe: 'هذا يذكرني بعميل آخر كان قلقاً أيضاً بشأن القسط.',
          foundBenefits:
            'وجدوا أن الفوائد طويلة الأجل تفوق بكثير الاستثمار الشهري.',
          discoveredWaiting: 'ما اكتشفوه هو أن الانتظار سيكلفهم أكثر.',
          foundPeaceOfMind: 'في النهاية، وجدوا أن راحة البال تستحق الاستثمار.',
        },
        objectives: {
          title: 'أهداف جلسة لعب الأدوار',
          sessionObjectives: 'أهداف جلسة لعب الأدوار',
          acknowledgePriceConcern: 'الاعتراف بقلق السعر',
          shareRelevantExperience: 'مشاركة التجربة ذات الصلة',
          demonstrateValueProposition: 'توضيح عرض القيمة',
          addressSpecificObjections: 'معالجة الاعتراضات المحددة',
          moveTowardsCommitment: 'التحرك نحو الالتزام',
        },
        persona: {
          background: 'الخلفية',
          profile: 'الملف الشخصي',
          style: 'الأسلوب',
          nameAndDemographics: 'الاسم والمعلومات الديموغرافية',
          occupation: 'المهنة',
          annualIncome: 'الدخل السنوي',
          education: 'التعليم',
          location: 'الموقع',
          clientBackground: 'خلفية العميل',
          workHistory: 'التاريخ الوظيفي',
          financialSituation: 'الوضع المالي',
          productKnowledge: 'معرفة المنتج',
          keyPriorities: 'الأولويات الرئيسية',
          communicationStyle: 'أسلوب التواصل',
          personalityTraits: 'سمات الشخصية',
          decisionMaking: 'اتخاذ القرار',
          male: 'ذكر',
          female: 'أنثى',
          year: 'سنة',
        },
        mobile: {
          conversation: 'المحادثة',
          salesInfo: 'معلومات المبيعات',
          guide: 'الدليل',
        },
      },
      feedback: {
        tabs: {
          summary: 'الملخص',
          skillsAssessment: 'تقييم المهارات',
          transcriptAnalysis: 'تحليل النص',
        },
        header: {
          title: 'تقييم لعب الأدوار',
          iconAlt: 'أيقونة تقييم لعب الأدوار',
        },
        errors: {
          transcriptAnalysis: 'تعذر استرداد تحليل النص.',
          skillsAssessment: 'تعذر استرداد تقييم المهارات.',
          summary: 'تعذر استرداد الملخص.',
        },
        modal: {
          title: 'تحليل لعب الأدوار غير متوفر لهذه الجلسة',
          description:
            'كانت محادثتك قصيرة جداً للتحليل. أكمل جلسة أطول لفتح تقرير مفصل عن نقاط القوة ومجالات التحسين وتقييم المهارات والمزيد!',
          imageAlt: 'معاينة تقرير التحليل',
          closeButton: 'إغلاق',
          metrics: {
            activeCommunication: 'التواصل النشط',
            conflictResolution: 'حل النزاعات',
            empathy: 'التعاطف',
            goalSetting: 'تحديد الأهداف',
          },
        },
      },
    },
  },
};
